export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  Byte: any;
  CountryCode: any;
  Currency: any;
  Date: any;
  DateTime: any;
  DID: any;
  Duration: any;
  EmailAddress: any;
  GUID: any;
  Hexadecimal: any;
  HexColorCode: any;
  HSL: any;
  HSLA: any;
  IBAN: any;
  IPv4: any;
  IPv6: any;
  ISBN: any;
  ISO8601Duration: any;
  JSON: any;
  JSONObject: any;
  JWT: any;
  Latitude: any;
  LocalDate: any;
  Locale: any;
  LocalEndTime: any;
  LocalTime: any;
  Long: any;
  Longitude: any;
  MAC: any;
  NegativeFloat: any;
  NegativeInt: any;
  NonEmptyString: any;
  NonNegativeFloat: any;
  NonNegativeInt: any;
  NonPositiveFloat: any;
  NonPositiveInt: any;
  Object: any;
  ObjectID: any;
  PhoneNumber: any;
  Port: any;
  PositiveFloat: any;
  PositiveInt: any;
  RGB: any;
  RGBA: any;
  SafeInt: any;
  SanitizedString: any;
  Time: any;
  Timestamp: any;
  TimeZone: any;
  UnsignedFloat: any;
  UnsignedInt: any;
  Upload: any;
  URL: any;
  UtcOffset: any;
  UUID: any;
  Void: any;
};

export type GQLAbTestCookie = {
  testId: Scalars['Int'];
  testVariant: Scalars['String'];
};

export type GQLAd = {
  __typename?: 'Ad';
  id: Scalars['ID'];
  background: GQLBackground;
  topImage?: Maybe<Scalars['Int']>;
  centerImage?: Maybe<Scalars['Int']>;
  centerText?: Maybe<Scalars['String']>;
  primaryButton?: Maybe<GQLButton>;
  secondaryButton?: Maybe<GQLButton>;
  settings: GQLSettings;
};

export type GQLAllegroLink = {
  __typename?: 'AllegroLink';
  url?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
};

export type GQLAllegroProductVariant = {
  __typename?: 'AllegroProductVariant';
  pmdId: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  categoryUrl?: Maybe<Scalars['String']>;
};

export type GQLAppConfig = {
  __typename?: 'AppConfig';
  images?: Maybe<GQLAppConfigImages>;
  billingAddress?: Maybe<GQLAppConfigBillingAddress>;
  phone?: Maybe<GQLAppConfigPhone>;
  lastSupportedVersion?: Maybe<GQLAppConfigLastSupportedVersion>;
  translations?: Maybe<GQLAppConfigTranslations>;
  onlinePaymentResponseUrl?: Maybe<GQLAppConfigPaymentUrl>;
  featureFlags?: Maybe<GQLAppConfigFeatureFlags>;
  sortFields?: Maybe<Array<Maybe<GQLAppConfigSortField>>>;
  /** @deprecated Mall Smart was canceled */
  clubs?: Maybe<GQLAppConfigClubs>;
  alternativePrice?: Maybe<GQLAppConfigAlternativePrice>;
  priceConfig?: Maybe<GQLAppConfigPricing>;
  exchangeRate?: Maybe<GQLAppConfigExchangeRate>;
  passwordRecoveryUrl?: Maybe<Scalars['String']>;
  searchSuggest?: Maybe<Array<GQLSearchSuggestLink>>;
  freeDeliveryForEmailMarketing: GQLAppConfigFreeDeliveryForEmailMarketing;
  mallSmart?: Maybe<GQLMallSmartConfig>;
  b2bAuthorizedBuyers?: Maybe<Scalars['Boolean']>;
};

export type GQLAppConfigAlternativePrice = {
  __typename?: 'AppConfigAlternativePrice';
  currency?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  decimalSeparator?: Maybe<Scalars['String']>;
  decimals?: Maybe<Scalars['Int']>;
  thousandSeparator?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['String']>;
  validTo?: Maybe<Scalars['String']>;
};

export type GQLAppConfigBillingAddress = {
  __typename?: 'AppConfigBillingAddress';
  showCid?: Maybe<Scalars['Boolean']>;
  /** @deprecated Cid2 is obsolete and unused */
  showCid2?: Maybe<Scalars['Boolean']>;
  showTin?: Maybe<Scalars['Boolean']>;
};

export type GQLAppConfigClubs = {
  __typename?: 'AppConfigClubs';
  mallSmartClubId?: Maybe<Scalars['Int']>;
};

export type GQLAppConfigExchangeRate = {
  __typename?: 'AppConfigExchangeRate';
  fromCurrency?: Maybe<Scalars['String']>;
  toCurrency?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['Float']>;
};

export type GQLAppConfigFeatureFlags = {
  __typename?: 'AppConfigFeatureFlags';
  showQrCodeForMallbox?: Maybe<Scalars['Boolean']>;
  /** @deprecated Mall Smart was canceled */
  mallSmartEnabled?: Maybe<Scalars['Boolean']>;
  showFbLoginButton?: Maybe<Scalars['Boolean']>;
  showQrCodeForPersonalPickup?: Maybe<Scalars['Boolean']>;
  showBarCodeScanner?: Maybe<Scalars['Boolean']>;
  showRememberCard?: Maybe<Scalars['Boolean']>;
  showLoyaltyClubs?: Maybe<Scalars['Boolean']>;
  showXSellDialog?: Maybe<Scalars['Boolean']>;
};

export type GQLAppConfigFreeDeliveryForEmailMarketing = {
  __typename?: 'AppConfigFreeDeliveryForEmailMarketing';
  enabled: Scalars['Boolean'];
  infoUrl?: Maybe<Scalars['String']>;
  partnersUrl?: Maybe<Scalars['String']>;
};

export type GQLAppConfigImages = {
  __typename?: 'AppConfigImages';
  basePath?: Maybe<Scalars['String']>;
  examplePath?: Maybe<Scalars['String']>;
  allowedWidths?: Maybe<Array<Maybe<Scalars['Int']>>>;
  allowedHeights?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type GQLAppConfigLastSupportedVersion = {
  __typename?: 'AppConfigLastSupportedVersion';
  ios?: Maybe<Scalars['Int']>;
  android?: Maybe<Scalars['Int']>;
};

export type GQLAppConfigPaymentUrl = {
  __typename?: 'AppConfigPaymentUrl';
  payU?: Maybe<Scalars['String']>;
  paymentGateway?: Maybe<Scalars['String']>;
  confirmation?: Maybe<Scalars['String']>;
};

export type GQLAppConfigPhone = {
  __typename?: 'AppConfigPhone';
  phoneCountryCode?: Maybe<Scalars['String']>;
  allowedPhoneCountryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GQLAppConfigPricing = {
  __typename?: 'AppConfigPricing';
  currency?: Maybe<Scalars['String']>;
  decimalSeparator?: Maybe<Scalars['String']>;
  decimals?: Maybe<Scalars['Int']>;
  thousandSeparator?: Maybe<Scalars['String']>;
};

export type GQLAppConfigSortField = {
  __typename?: 'AppConfigSortField';
  title?: Maybe<Scalars['String']>;
  sortId?: Maybe<Scalars['String']>;
};

export type GQLAppConfigTranslation = {
  __typename?: 'AppConfigTranslation';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GQLAppConfigTranslations = {
  __typename?: 'AppConfigTranslations';
  errorMessages?: Maybe<Array<Maybe<GQLAppConfigTranslation>>>;
  registration?: Maybe<Array<Maybe<GQLAppConfigTranslation>>>;
};

export type GQLAppNotifications = {
  __typename?: 'AppNotifications';
  created?: Maybe<Scalars['String']>;
  device?: Maybe<Scalars['String']>;
  os?: Maybe<Scalars['String']>;
  allowNewsletterEmails?: Maybe<Scalars['Boolean']>;
  allowNewsletterSms?: Maybe<Scalars['Boolean']>;
  allowMarketing3p?: Maybe<Scalars['Boolean']>;
  allowPersonalData3p?: Maybe<Scalars['Boolean']>;
  newsCheck?: Maybe<Scalars['Boolean']>;
  orderStateCheck?: Maybe<Scalars['Boolean']>;
  reviewsCheck?: Maybe<Scalars['Boolean']>;
};

export type GQLArticleBundleInput = {
  id: Scalars['ID'];
};

export type GQLArticleServiceInput = {
  id: Scalars['ID'];
  variantId: Scalars['ID'];
  type: GQLArticleServiceType;
};

export enum GQLArticleServiceType {
  Insurance = 'insurance',
  ReturnGuarantee = 'return_guarantee',
  Warranty = 'warranty'
}

export type GQLAutocompleteResult = {
  __typename?: 'AutocompleteResult';
  products: Array<GQLProductAutocomplete>;
  items: Array<GQLItemsAutocomplete>;
  totalProducts: Scalars['Int'];
  inaccurateResult: Scalars['Boolean'];
};

export type GQLBackground = {
  __typename?: 'Background';
  color?: Maybe<Scalars['String']>;
  gradient?: Maybe<GQLBackgroundGradient>;
};

export type GQLBackgroundBanner = {
  __typename?: 'BackgroundBanner';
  bannerId: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  urlNewWindow: Scalars['Boolean'];
  skyscraperImage?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  gaTag?: Maybe<Scalars['String']>;
};

export type GQLBackgroundGradient = {
  __typename?: 'BackgroundGradient';
  begin?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  colors?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GQLBaseFinancialOfferResult = {
  provider: GQLFinancialOfferProviders;
};

export type GQLBaseProductBundle = {
  __typename?: 'BaseProductBundle';
  type: Scalars['String'];
  lowestPrice: Scalars['Float'];
  variants: Array<Maybe<GQLProductBundleVariant>>;
};

export type GQLBazaarBox = {
  __typename?: 'BazaarBox';
  ids: Array<Scalars['ID']>;
  label: Scalars['String'];
  lowestPrice: Scalars['Float'];
  products: Array<GQLProduct>;
};

export type GQLBeginDeliveryPersonalPickup = {
  __typename?: 'BeginDeliveryPersonalPickup';
  orderId: Scalars['String'];
  pickupCode: Scalars['String'];
  trackingTitle?: Maybe<Scalars['String']>;
};

export type GQLBestSellersQueryInput = {
  /** Default pagination is set - limit 40 offset 0 */
  limit: Scalars['Int'];
  filters?: Maybe<Array<GQLProductFilterValueInput>>;
};


export type GQLBillingAddress = {
  __typename?: 'BillingAddress';
  id: Scalars['ID'];
  street: Scalars['String'];
  city: Scalars['String'];
  zip: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  isCompany?: Maybe<Scalars['Boolean']>;
  companyName?: Maybe<Scalars['String']>;
  cid?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  verificationStatus?: Maybe<GQLBillingAddressVerificationStatus>;
};

export type GQLBillingAddressCollection = {
  __typename?: 'BillingAddressCollection';
  items: Array<GQLBillingAddress>;
  hits: Scalars['Int'];
};

export enum GQLBillingAddressVerificationStatus {
  UnknownVerificationStatus = 'UNKNOWN_VERIFICATION_STATUS',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Cancelled = 'CANCELLED',
  Verified = 'VERIFIED',
  Outdated = 'OUTDATED'
}

export type GQLBonusSet = {
  __typename?: 'BonusSet';
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  brief?: Maybe<Scalars['String']>;
  categoryUrlKey?: Maybe<Scalars['String']>;
  urlKey: Scalars['String'];
  description: Scalars['String'];
  availabilityKey?: Maybe<Scalars['String']>;
  isAdultOnly: Scalars['Boolean'];
  mainMediaId?: Maybe<Scalars['Int']>;
  isMarketplace?: Maybe<Scalars['Boolean']>;
  variants: Array<GQLBonusSetVariant>;
  price: GQLBonusSetPrice;
  secondPrice?: Maybe<GQLSecondPrice>;
  labels?: Maybe<Array<GQLBonusSetLabel>>;
  energyLabel?: Maybe<Array<GQLBonusSetEnergyLabel>>;
  parameters?: Maybe<Array<GQLBonusSetParameters>>;
  ranking?: Maybe<GQLBonusSetRanking>;
  availability: GQLBonusSetAvailability;
  brand?: Maybe<Array<GQLBonusSetBrand>>;
  variantData?: Maybe<Array<GQLBonusSetVariantData>>;
  productType?: Maybe<Array<GQLBonusSetProductType>>;
  gifts: Array<GQLBonusSetGifts>;
  giftDetails: Array<GQLGiftDetails>;
  estimatedDeliveries?: Maybe<GQLEstimatedDelivery>;
  mallService?: Maybe<GQLMallService>;
  breadcrumbs: Array<GQLCategory>;
  variantStickers: Array<GQLProductVariantStickers>;
  freeDelivery: Scalars['Boolean'];
};


export type GQLBonusSetEstimatedDeliveriesArgs = {
  type?: Maybe<GQLEstimatedDeliveriesType>;
};


export type GQLBonusSetVariantStickersArgs = {
  useCase?: Maybe<GQLVariantStickerUseCase>;
};

export type GQLBonusSetAvailability = {
  __typename?: 'BonusSetAvailability';
  key: Scalars['String'];
  ourAvailability: Scalars['Int'];
  externalAvailability: Scalars['Int'];
  supplierAvailability: Scalars['Int'];
  status: Scalars['String'];
  isAvailable: Scalars['Boolean'];
  sourceCountryId?: Maybe<Scalars['Int']>;
  supplierDeliveryTermDays?: Maybe<Scalars['Int']>;
  supplierProcessingTermDays?: Maybe<Scalars['Int']>;
  numeric?: Maybe<Scalars['Int']>;
};

export type GQLBonusSetBrand = {
  __typename?: 'BonusSetBrand';
  urlKey: Scalars['String'];
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['Int']>;
};

export type GQLBonusSetEnergyLabel = {
  __typename?: 'BonusSetEnergyLabel';
  label: Scalars['String'];
  class: Scalars['String'];
  entityId: Scalars['String'];
  mediaId?: Maybe<Scalars['Int']>;
  informationSheetId?: Maybe<Scalars['Int']>;
  informationSheetMimeType?: Maybe<Scalars['String']>;
};

export type GQLBonusSetGifts = {
  __typename?: 'BonusSetGifts';
  id: Scalars['String'];
  title: Scalars['String'];
  isAvailable: Scalars['Boolean'];
  count: Scalars['Int'];
};

export type GQLBonusSetLabel = {
  __typename?: 'BonusSetLabel';
  id: Scalars['String'];
};

export type GQLBonusSetParameters = {
  __typename?: 'BonusSetParameters';
  id: Scalars['String'];
};

export type GQLBonusSetPrice = {
  __typename?: 'BonusSetPrice';
  price?: Maybe<Scalars['Float']>;
  originalPrice: Scalars['Float'];
  recommendedRetailPrice?: Maybe<Scalars['Float']>;
  actualPrice?: Maybe<Scalars['Float']>;
  basePrice?: Maybe<Scalars['Float']>;
  rrp?: Maybe<Scalars['Float']>;
  rrpSave?: Maybe<Scalars['Float']>;
  rrpSavePercent?: Maybe<Scalars['Int']>;
  vatRate: Scalars['Float'];
  currency: Scalars['String'];
  inPromotion?: Maybe<Scalars['Boolean']>;
  promotionAmount?: Maybe<Scalars['Int']>;
  promotionEnd?: Maybe<Scalars['Int']>;
  promotionPrice?: Maybe<Scalars['Float']>;
  minimalRefund?: Maybe<Scalars['Float']>;
  decimalRounds?: Maybe<Scalars['String']>;
  currencyAbr?: Maybe<Scalars['String']>;
  discountPrice?: Maybe<Scalars['Boolean']>;
  discountPromotionPrice?: Maybe<Scalars['Boolean']>;
  discountMocPrice?: Maybe<Scalars['Boolean']>;
  actualDiscount?: Maybe<Scalars['Float']>;
  productsActualPrice?: Maybe<Scalars['Float']>;
  pricingGroupId?: Maybe<Scalars['String']>;
  savePricePercent?: Maybe<Scalars['Float']>;
  savePrice?: Maybe<Scalars['Float']>;
  isRelevantDiscount?: Maybe<Scalars['Boolean']>;
  currencyCode?: Maybe<Scalars['String']>;
};

export type GQLBonusSetProductType = {
  __typename?: 'BonusSetProductType';
  id: Scalars['String'];
};

export type GQLBonusSetRanking = {
  __typename?: 'BonusSetRanking';
  averageRanking: Scalars['Float'];
  rankingCount: Scalars['Int'];
  textRankingCount: Scalars['Int'];
};

export type GQLBonusSetVariant = {
  __typename?: 'BonusSetVariant';
  id: Scalars['ID'];
  brand: Scalars['String'];
  titleFull: Scalars['String'];
  mediaId: Scalars['Int'];
  urlKey: Scalars['String'];
  average: Scalars['Float'];
  rankingCount: Scalars['Int'];
  availability?: Maybe<GQLBonusSetVariantAvailability>;
};

export type GQLBonusSetVariantAvailability = {
  __typename?: 'BonusSetVariantAvailability';
  status: Scalars['String'];
};

export type GQLBonusSetVariantData = {
  __typename?: 'BonusSetVariantData';
  id: Scalars['String'];
  division: Scalars['String'];
  packageGroupId: Scalars['String'];
  size: GQLVariantDataSize;
  weight: GQLVariantDataWeight;
  labels: Array<Scalars['String']>;
  extendedWarranty: Array<GQLVariantDataExtendedWarranty>;
  installationService: Array<GQLVariantDataInstallationService>;
  return60DaysService: Array<GQLVariantDataReturn60DaysService>;
  insurance: Array<GQLVariantDataInsurance>;
  bundles: Array<GQLProductBundle>;
  brand: GQLVariantDataBrand;
  price: Scalars['Float'];
  productTypeId: Scalars['String'];
  title: Scalars['String'];
  mainMediaId?: Maybe<Scalars['Int']>;
  ranking: GQLBonusSetRanking;
  discussionCount: Scalars['Int'];
  mediaIds: Array<Scalars['Int']>;
  urlKey: Scalars['String'];
  categoryUrlKey: Scalars['String'];
  count: Scalars['Int'];
};

export type GQLBrand = {
  __typename?: 'Brand';
  id: Scalars['ID'];
  title: Scalars['String'];
  mediaId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  coupon?: Maybe<GQLCoupon>;
};

export type GQLBrandManufacturer = {
  __typename?: 'BrandManufacturer';
  id?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type GQLBrandSiS = GQLIBaseSiSResponse & {
  __typename?: 'BrandSiS';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['Int']>;
  breadcrumbs: Array<GQLCategory>;
  bestSellers: Array<GQLProduct>;
  productCollection?: Maybe<GQLProductCollection>;
  category?: Maybe<GQLContentCategory>;
};


export type GQLBrandSiSBestSellersArgs = {
  query?: Maybe<GQLBestSellersQueryInput>;
};


export type GQLBrandSiSProductCollectionArgs = {
  query?: Maybe<GQLProductCollectionQueryInput>;
};

export type GQLButton = {
  __typename?: 'Button';
  target?: Maybe<GQLTarget>;
  backgroundColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};


export enum GQLCacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type GQLCampaign = {
  __typename?: 'Campaign';
  id: Scalars['String'];
  beforeContentId?: Maybe<Scalars['Int']>;
  afterContentId?: Maybe<Scalars['Int']>;
  afterContent?: Maybe<GQLContent>;
  beforeContent?: Maybe<GQLContent>;
  url: Scalars['String'];
  name: Scalars['String'];
  labels: Array<Scalars['String']>;
  status: GQLCampaignStatus;
  isDateValid: Scalars['Boolean'];
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
  showActionPrice: Scalars['Boolean'];
  abTestVariant: Scalars['String'];
  productListSorting?: Maybe<Scalars['String']>;
  productSorting?: Maybe<Scalars['String']>;
  productSortingDefinitions?: Maybe<Array<GQLProductSortingDefinitions>>;
  productFilteringDefinitions?: Maybe<Array<GQLProductFilteringDefinitions>>;
  menuSorting?: Maybe<Scalars['String']>;
  hasCustomMenu?: Maybe<Scalars['Boolean']>;
  showCampaignCounter?: Maybe<Scalars['Boolean']>;
  showProductCounter?: Maybe<Scalars['Boolean']>;
  sortingLabels: Array<Scalars['String']>;
  imageId: Scalars['Int'];
  recommended?: Maybe<GQLCampaignRecommended>;
  productListTitle?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaKeywords?: Maybe<Scalars['String']>;
  mobileMenuRows?: Maybe<Scalars['Int']>;
  desktopMenuRows?: Maybe<Scalars['Int']>;
  userErrorMessage?: Maybe<Scalars['String']>;
  displayProductListWhenNoProducts: Scalars['Boolean'];
  displayCategoryBoxInTheEndOfList: Scalars['Boolean'];
  styles?: Maybe<GQLCampaignStyles>;
  showOnDetail: Scalars['Boolean'];
  uspBadge?: Maybe<Scalars['String']>;
  productCollection?: Maybe<GQLProductCollection>;
  showAvailabilityBox: Scalars['Boolean'];
  availabilityBoxLimit: Scalars['Int'];
};


export type GQLCampaignProductCollectionArgs = {
  query?: Maybe<GQLProductCollectionQueryInput>;
};

export type GQLCampaignAbTest = {
  __typename?: 'CampaignAbTest';
  id: Scalars['ID'];
  abTestId: Scalars['String'];
};

export type GQLCampaignRecommended = {
  __typename?: 'CampaignRecommended';
  label: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  showActionPrice: Scalars['Boolean'];
  items: Array<GQLProductCollectionItems>;
};

export enum GQLCampaignStatus {
  Public = 'PUBLIC',
  Protected = 'PROTECTED',
  Hidden = 'HIDDEN'
}

export type GQLCampaignStylePart = {
  __typename?: 'CampaignStylePart';
  banner?: Maybe<Scalars['Object']>;
  heading?: Maybe<Scalars['Object']>;
  h1?: Maybe<Scalars['Object']>;
  h2?: Maybe<Scalars['Object']>;
  legal?: Maybe<Scalars['Object']>;
  headerStickerContainer?: Maybe<Scalars['Object']>;
  headerSticker?: Maybe<Scalars['Object']>;
  breadcrumb?: Maybe<Scalars['Object']>;
  badge?: Maybe<Scalars['Object']>;
  uspBadge?: Maybe<Scalars['Object']>;
  additionalText?: Maybe<Scalars['Object']>;
};

export type GQLCampaignStyles = {
  __typename?: 'CampaignStyles';
  cssOutput?: Maybe<Scalars['String']>;
  mobile?: Maybe<GQLCampaignStylePart>;
  desktop?: Maybe<GQLCampaignStylePart>;
  tablet?: Maybe<GQLCampaignStylePart>;
};

export type GQLCarousel = {
  __typename?: 'Carousel';
  pmdId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  categoryUrl?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['String']>;
  productTitle?: Maybe<Scalars['String']>;
  productImg?: Maybe<Scalars['String']>;
  productImgAlternative?: Maybe<Scalars['String']>;
};

export type GQLCarouselProductsInput = {
  limit: Scalars['Int'];
  sort: GQLCarouselProductsSort;
  categoryId?: Maybe<Scalars['Int']>;
  categoryIds?: Maybe<Array<Scalars['Int']>>;
  productTypes?: Maybe<Array<Scalars['String']>>;
  minPrice?: Maybe<Scalars['Float']>;
  label?: Maybe<Scalars['String']>;
  division?: Maybe<Scalars['String']>;
};

export enum GQLCarouselProductsSort {
  Bestsellers = 'BESTSELLERS',
  Rand = 'RAND'
}

export type GQLCartAddInput = {
  articleId: Scalars['ID'];
  amount: Scalars['Int'];
  bundles?: Maybe<Array<GQLArticleBundleInput>>;
  isBonusSet?: Maybe<Scalars['Boolean']>;
  services?: Maybe<Array<GQLArticleServiceInput>>;
};

export type GQLCartDeleteInput = {
  articleId: Scalars['ID'];
};

export type GQLCartDiscountCode = {
  __typename?: 'CartDiscountCode';
  title: Scalars['String'];
  code: Scalars['String'];
  currency: Scalars['String'];
  type: Scalars['String'];
  target: GQLViewTarget;
  valid_until: Scalars['String'];
  promotion?: Maybe<GQLCartDiscountCodePromotion>;
};

export type GQLCartDiscountCodePromotion = {
  __typename?: 'CartDiscountCodePromotion';
  message: Scalars['String'];
  type: Scalars['String'];
  active: Scalars['Boolean'];
};

export type GQLCartPreview = {
  __typename?: 'CartPreview';
  amount: GQLCartPreviewAmount;
  cartId: Scalars['Int'];
  deliveries: Array<GQLCartPreviewDelivery>;
  hasDigitalContent: Scalars['Boolean'];
  hasMarketplace: Scalars['Boolean'];
  hasServices: Scalars['Boolean'];
  isB2B: Scalars['Boolean'];
  price: GQLCartPreviewPrice;
  shipping: GQLCartPreviewShipping;
  userAddresses: GQLCartPreviewUserAddresses;
  discount: GQLCartPreviewDiscount;
};

export type GQLCartPreviewAmount = {
  __typename?: 'CartPreviewAmount';
  articles: Scalars['Int'];
  pieces: Scalars['Int'];
};

export type GQLCartPreviewArticle = {
  __typename?: 'CartPreviewArticle';
  articleId: Scalars['ID'];
  availability?: Maybe<GQLCartPreviewProductAvailability>;
  brand?: Maybe<Scalars['String']>;
  cartItemId: Scalars['Int'];
  count: Scalars['Int'];
  createTime: Scalars['DateTime'];
  hasReservation: Scalars['Boolean'];
  isAdultOnly: Scalars['Boolean'];
  mainMediaId?: Maybe<Scalars['Int']>;
  marketplacePartnerId?: Maybe<Scalars['Int']>;
  materialType?: Maybe<Scalars['String']>;
  price?: Maybe<GQLCartPreviewArticlePrice>;
  priceRibbon?: Maybe<GQLCartPreviewArticlePriceRibbon>;
  target?: Maybe<GQLViewTarget>;
  title: Scalars['String'];
  type: Scalars['String'];
  hasGift: Scalars['Boolean'];
  simpleTitle: Scalars['String'];
  url: Scalars['String'];
  params: Array<GQLCartPreviewArticleParams>;
  bundles: Array<GQLCartPreviewArticleBundle>;
  variants: Array<GQLCartPreviewArticleVariant>;
  marketplacePartner?: Maybe<GQLMarketplaceProductData>;
};

export type GQLCartPreviewArticleBundle = {
  __typename?: 'CartPreviewArticleBundle';
  variantId?: Maybe<Scalars['Int']>;
  actualPrice: Scalars['Int'];
  decimalRound?: Maybe<Scalars['Int']>;
  vatRate?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  type: Scalars['String'];
  active: Scalars['Boolean'];
  sort?: Maybe<Scalars['Int']>;
  brief?: Maybe<Scalars['String']>;
  rrpPrice?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  originalPrice?: Maybe<Scalars['Int']>;
  rrpSavePercent?: Maybe<Scalars['Int']>;
  mediaUrl?: Maybe<Scalars['String']>;
};

export type GQLCartPreviewArticleParams = {
  __typename?: 'CartPreviewArticleParams';
  key: Scalars['String'];
  title: Scalars['String'];
  value: Scalars['String'];
  css: Scalars['String'];
};

export type GQLCartPreviewArticlePrice = {
  __typename?: 'CartPreviewArticlePrice';
  actual: Scalars['Float'];
  type?: Maybe<Scalars['String']>;
};

export type GQLCartPreviewArticlePriceRibbon = {
  __typename?: 'CartPreviewArticlePriceRibbon';
  bgColor: Scalars['String'];
  imageId: Scalars['Int'];
};

export type GQLCartPreviewArticleVariant = {
  __typename?: 'CartPreviewArticleVariant';
  variantId: Scalars['Int'];
  title: Scalars['String'];
  mainMediaId: Scalars['Int'];
  isAdultOnly: Scalars['Boolean'];
};

export type GQLCartPreviewDelivery = {
  __typename?: 'CartPreviewDelivery';
  articles: Array<GQLCartPreviewArticle>;
  deliveryMessage?: Maybe<GQLCartPreviewDeliveryMessage>;
  deliveryBy?: Maybe<GQLCartPreviewDeliverySupplier>;
};

export type GQLCartPreviewDeliveryMessage = {
  __typename?: 'CartPreviewDeliveryMessage';
  message: Scalars['String'];
  bgColor: Scalars['String'];
  imageId?: Maybe<Scalars['Int']>;
  htmlColor?: Maybe<Scalars['String']>;
};

export type GQLCartPreviewDeliverySupplier = {
  __typename?: 'CartPreviewDeliverySupplier';
  title: Scalars['String'];
  supplierName: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type GQLCartPreviewDiscount = {
  __typename?: 'CartPreviewDiscount';
  value: Scalars['Float'];
  codes: Array<GQLCartPreviewDiscountCode>;
  headerDisplayText?: Maybe<Scalars['String']>;
};

export type GQLCartPreviewDiscountCode = {
  __typename?: 'CartPreviewDiscountCode';
  name: Scalars['String'];
  amount: Scalars['Float'];
  price: Scalars['Float'];
  currency: Scalars['String'];
  type: GQLCartPreviewDiscountCodeType;
  displayText: Scalars['String'];
};

export enum GQLCartPreviewDiscountCodeType {
  G = 'G',
  D = 'D',
  A = 'A'
}

export type GQLCartPreviewPrice = {
  __typename?: 'CartPreviewPrice';
  base: Scalars['Float'];
  total: Scalars['Float'];
  vat: Scalars['Float'];
  currency: Scalars['String'];
  decimalRounds: Scalars['Int'];
};

export type GQLCartPreviewProductAvailability = {
  __typename?: 'CartPreviewProductAvailability';
  isAvailable: Scalars['Boolean'];
  text: Scalars['String'];
  inStock: Scalars['Int'];
};

export type GQLCartPreviewShipping = {
  __typename?: 'CartPreviewShipping';
  zip: Scalars['String'];
};

export type GQLCartPreviewUserAddresses = {
  __typename?: 'CartPreviewUserAddresses';
  isBillingValid: Scalars['Boolean'];
  isShippingValid: Scalars['Boolean'];
};

export type GQLCartUpdateInput = {
  articleId: Scalars['ID'];
  amount: Scalars['Int'];
};

export type GQLCategory = {
  id: Scalars['ID'];
  footer?: Maybe<Array<GQLFooter>>;
  shoppingWizard?: Maybe<GQLShoppingWizardPreview>;
  title: Scalars['String'];
  titleFull?: Maybe<Scalars['String']>;
  titleStructured?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['Int']>;
  secondaryMediaId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  metaDescription?: Maybe<Scalars['String']>;
  metaKeywords?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  howto?: Maybe<Scalars['String']>;
  productOrder?: Maybe<Scalars['String']>;
  breadcrumbs: Array<GQLCategory>;
  children: Array<GQLCategory>;
  isRepresentative: Scalars['Boolean'];
  isMainTile: Scalars['Boolean'];
  menu: Array<GQLMixedChildren>;
  typeVersion: Scalars['Int'];
  isTrendy: Scalars['Boolean'];
  indexSeo?: Maybe<Scalars['Boolean']>;
  giftHelperUrl?: Maybe<Scalars['String']>;
  giftHelperTitle?: Maybe<Scalars['String']>;
};


export type GQLCategoryDescriptionArgs = {
  normalizeHtml?: Maybe<GQLNormalizeInput>;
};


export type GQLCategoryChildrenArgs = {
  sort?: Maybe<GQLCategorySort>;
  visibility?: Maybe<GQLCategoryVisibility>;
};


export type GQLCategoryMenuArgs = {
  usedFilters?: Maybe<Array<GQLProductFilterValueInput>>;
};

export type GQLCategoryAutocomplete = GQLIItemAutocompleteBase & {
  __typename?: 'CategoryAutocomplete';
  id: Scalars['ID'];
  title: Scalars['String'];
  /** should be 'category', 'category_with_brand', param */
  type: Scalars['String'];
  urlKey: Scalars['String'];
  brand?: Maybe<GQLBrand>;
  url?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
};

export type GQLCategoryProductCollectionQueryInput = {
  /** Default pagination is set - limit 40 offset 0 */
  pagination?: Maybe<GQLProductCollectionPaginationInput>;
  productSorting?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<GQLProductFilterValueInput>>;
  allFilters?: Maybe<Scalars['Boolean']>;
  sortVersion?: Maybe<Scalars['String']>;
};

export enum GQLCategorySort {
  UrlPriorAndOrder = 'URL_PRIOR_AND_ORDER',
  NoSorting = 'NO_SORTING'
}

export enum GQLCategoryVisibility {
  Visible = 'VISIBLE',
  NotVisible = 'NOT_VISIBLE',
  All = 'ALL',
  ForAdvisor = 'FOR_ADVISOR'
}

export type GQLChangeEmailInput = {
  newEmail: Scalars['String'];
  password: Scalars['String'];
};

export type GQLChangePasswordInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type GQLCheckout = {
  __typename?: 'Checkout';
  deliveries: Array<GQLCheckoutDelivery>;
};

export type GQLCheckoutDelivery = {
  __typename?: 'CheckoutDelivery';
  deliveryId: Scalars['String'];
};

export type GQLCheckoutOrder = {
  __typename?: 'CheckoutOrder';
  id?: Maybe<Scalars['ID']>;
  token: Scalars['String'];
};

export type GQLClubDomain = {
  __typename?: 'ClubDomain';
  id: Scalars['Int'];
  clubId: Scalars['Int'];
  domain: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
};

export type GQLClubForm = GQLClubPetForm;

export type GQLClubPetForm = {
  __typename?: 'ClubPetForm';
  animal: Scalars['String'];
  name: Scalars['String'];
  birthDate: Scalars['String'];
  castration: Scalars['String'];
  breed: Scalars['String'];
};

export type GQLClubSubscription = {
  __typename?: 'ClubSubscription';
  id: Scalars['ID'];
  status: GQLClubSubscriptionStatus;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
  /** @deprecated Mall Prime was canceled */
  isTrial: Scalars['Boolean'];
  /** @deprecated Mall Prime was canceled */
  isRecurring: Scalars['Boolean'];
};

export type GQLClubSubscriptionCollection = {
  __typename?: 'ClubSubscriptionCollection';
  items: Array<GQLClubSubscription>;
  count: Scalars['Int'];
};

export enum GQLClubSubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Inactive = 'inactive',
  Processing = 'processing',
  Unknown = 'unknown',
  Waiting = 'waiting'
}

export type GQLCncLink = {
  __typename?: 'CncLink';
  title: Scalars['String'];
  link: Scalars['String'];
};

export type GQLConfig = {
  __typename?: 'Config';
  featureFlags: Scalars['Object'];
  shopConfig: Scalars['Object'];
  campaignAbTests: Array<GQLCampaignAbTest>;
  menuAbTests: Array<GQLMenuAbTest>;
  app?: Maybe<GQLAppConfig>;
};


export type GQLConfigMenuAbTestsArgs = {
  menuType: Scalars['String'];
};

export type GQLContent = {
  __typename?: 'Content';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaKeywords?: Maybe<Scalars['String']>;
  previewCode?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  js?: Maybe<Array<Scalars['String']>>;
  css?: Maybe<Array<Scalars['String']>>;
  lastChange?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  tags: Array<Scalars['String']>;
};


export type GQLContentBodyArgs = {
  normalizeHtml?: Maybe<GQLNormalizeInput>;
};

export type GQLContentCategory = GQLCategory & {
  __typename?: 'ContentCategory';
  id: Scalars['ID'];
  contentId?: Maybe<Scalars['Int']>;
  content?: Maybe<GQLContent>;
  footer?: Maybe<Array<GQLFooter>>;
  shoppingWizard?: Maybe<GQLShoppingWizardPreview>;
  title: Scalars['String'];
  titleFull?: Maybe<Scalars['String']>;
  titleStructured?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['Int']>;
  secondaryMediaId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  metaDescription?: Maybe<Scalars['String']>;
  metaKeywords?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  howto?: Maybe<Scalars['String']>;
  productOrder?: Maybe<Scalars['String']>;
  breadcrumbs: Array<GQLCategory>;
  children: Array<GQLCategory>;
  isRepresentative: Scalars['Boolean'];
  isMainTile: Scalars['Boolean'];
  menu: Array<GQLMixedChildren>;
  typeVersion: Scalars['Int'];
  isTrendy: Scalars['Boolean'];
  indexSeo?: Maybe<Scalars['Boolean']>;
  giftHelperUrl?: Maybe<Scalars['String']>;
  giftHelperTitle?: Maybe<Scalars['String']>;
  coupon?: Maybe<GQLCoupon>;
};


export type GQLContentCategoryContentArgs = {
  addContentClass?: Maybe<Scalars['Boolean']>;
  query?: Maybe<GQLGetContentQuery>;
};


export type GQLContentCategoryDescriptionArgs = {
  normalizeHtml?: Maybe<GQLNormalizeInput>;
};


export type GQLContentCategoryChildrenArgs = {
  sort?: Maybe<GQLCategorySort>;
  visibility?: Maybe<GQLCategoryVisibility>;
};


export type GQLContentCategoryMenuArgs = {
  usedFilters?: Maybe<Array<GQLProductFilterValueInput>>;
};


export type GQLCoupon = {
  __typename?: 'Coupon';
  expirationDate: Scalars['DateTime'];
  nominalValue?: Maybe<GQLCouponNominalValue>;
  percentualValue?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type GQLCouponNominalValue = {
  __typename?: 'CouponNominalValue';
  value: Scalars['Int'];
  currency: Scalars['String'];
};

export type GQLCreateBillingAddressFromCompanyIdInput = {
  tin?: Maybe<Scalars['String']>;
  cid?: Maybe<Scalars['String']>;
};

export type GQLCreateBillingAddressFromCompanyIdResponse = {
  __typename?: 'CreateBillingAddressFromCompanyIdResponse';
  statusCode?: Maybe<Scalars['Int']>;
  billingProfileId?: Maybe<Scalars['Int']>;
  message: Scalars['String'];
};

export type GQLCreateBillingAddressInput = {
  street: Scalars['String'];
  city: Scalars['String'];
  zip: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  cid?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
};

export type GQLCreateCustomerConsentInput = {
  code: Scalars['ID'];
  isAllowed: Scalars['Boolean'];
};

export type GQLCreateProductReviewInput = {
  variantId: Scalars['ID'];
  productId?: Maybe<Scalars['ID']>;
  showAuthor: Scalars['Boolean'];
  rank: Scalars['Float'];
  message?: Maybe<Scalars['String']>;
  cons?: Maybe<Array<Scalars['String']>>;
  pros?: Maybe<Array<Scalars['String']>>;
  medias?: Maybe<Array<GQLReviewMediaInput>>;
  imageUploads?: Maybe<Array<Scalars['Upload']>>;
};

export type GQLCreateShippingAddressInput = {
  street: Scalars['String'];
  city: Scalars['String'];
  zip: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};


export type GQLCustomerClub = {
  __typename?: 'CustomerClub';
  card?: Maybe<GQLCustomerClubPaymentCard>;
  trialAvailable?: Maybe<Scalars['Boolean']>;
  paidAvailable?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Float']>;
  isDiscount: Scalars['Boolean'];
  isInTrial: Scalars['Boolean'];
  status?: Maybe<Scalars['String']>;
  /** @deprecated Mall Prime was canceled */
  isRecurring: Scalars['Boolean'];
  trial?: Maybe<GQLSubscriptionRange>;
  isPaidSubscription: Scalars['Boolean'];
  subscriptionRange?: Maybe<GQLSubscriptionRange>;
  subscription?: Maybe<GQLV2CustomerClubSubscription>;
  isTrialEnding: Scalars['Boolean'];
  isSubscriptionEnding: Scalars['Boolean'];
};

export type GQLCustomerClubPaymentCard = {
  __typename?: 'CustomerClubPaymentCard';
  id: Scalars['ID'];
  longMasked: Scalars['String'];
  shortMasked: Scalars['String'];
  expiration: Scalars['DateTime'];
};

export type GQLCustomerConsent = {
  __typename?: 'CustomerConsent';
  code: Scalars['ID'];
  isAllowed?: Maybe<Scalars['Boolean']>;
};



export type GQLDeleteAddressInput = {
  id: Scalars['ID'];
};

export type GQLDeliveryItem = {
  __typename?: 'DeliveryItem';
  name?: Maybe<Scalars['String']>;
  deliveryFrom?: Maybe<Scalars['String']>;
  deliveryTo?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  totalPrice: Scalars['Float'];
  type?: Maybe<Scalars['String']>;
  closeTime?: Maybe<Scalars['DateTime']>;
  readyForPickup?: Maybe<Scalars['Boolean']>;
  priceReasons?: Maybe<Array<Maybe<GQLDeliveryItemPriceReason>>>;
};

export type GQLDeliveryItemPriceReason = {
  __typename?: 'DeliveryItemPriceReason';
  commonLabels?: Maybe<Array<Maybe<Scalars['String']>>>;
  ruleId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


export type GQLDigitalContentAuthorizedRequest = {
  __typename?: 'DigitalContentAuthorizedRequest';
  authorizationId: Scalars['String'];
  phone: Scalars['String'];
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
};

export type GQLDigitalContentBundle = {
  __typename?: 'DigitalContentBundle';
  type: Scalars['String'];
  variants: Array<Maybe<GQLDigitalContentBundleVariant>>;
};

export type GQLDigitalContentBundleInfo = {
  __typename?: 'DigitalContentBundleInfo';
  id: Scalars['String'];
  originalPrice: Scalars['Float'];
  bundledPrice: Scalars['Float'];
  attached: Scalars['Boolean'];
};

export type GQLDigitalContentBundleVariant = {
  __typename?: 'DigitalContentBundleVariant';
  id: Scalars['String'];
  title: Scalars['String'];
  actualPrice: Scalars['Float'];
  brief: Scalars['String'];
  rrpSavePercent: Scalars['Float'];
  attached: Scalars['Boolean'];
};

export type GQLDigitalContentLicenceKeyStatus = {
  __typename?: 'DigitalContentLicenceKeyStatus';
  id: Scalars['ID'];
  status: GQLLicenceKeyStatus;
};

export type GQLDigitalContentLicenceProduct = {
  __typename?: 'DigitalContentLicenceProduct';
  productId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  licenceKeyStatuses: Array<GQLDigitalContentLicenceKeyStatus>;
};

export type GQLDigitalContentLicenceProductsCollection = {
  __typename?: 'DigitalContentLicenceProductsCollection';
  items: Array<GQLDigitalContentLicenceProduct>;
  hits: Scalars['Int'];
};

export type GQLDigitalLicenceProductKey = {
  __typename?: 'DigitalLicenceProductKey';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type GQLDigitalLicenceProductKeyValue = {
  __typename?: 'DigitalLicenceProductKeyValue';
  activationCode: Scalars['String'];
  downloadLink: Scalars['String'];
  activationData: Scalars['String'];
  activationDataType: Scalars['String'];
  type: Scalars['String'];
};

export type GQLDiscussionCollection = {
  __typename?: 'DiscussionCollection';
  items: Array<GQLDiscussionComment>;
  totalCount: Scalars['Int'];
};

export type GQLDiscussionComment = {
  __typename?: 'DiscussionComment';
  id: Scalars['ID'];
  message: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  parentId?: Maybe<Scalars['String']>;
  user?: Maybe<GQLDiscussionCommentUser>;
};

export type GQLDiscussionCommentUser = {
  __typename?: 'DiscussionCommentUser';
  official: Scalars['Boolean'];
  nick?: Maybe<Scalars['String']>;
  nickSuffix?: Maybe<Scalars['String']>;
};

export type GQLDiscussionsCommentInput = {
  message: Scalars['String'];
  source: GQLDiscussionsCommentSourcesEnum;
  showAuthor: Scalars['Boolean'];
  sendNotification: Scalars['Boolean'];
  parentId?: Maybe<Scalars['ID']>;
  rootCommentId?: Maybe<Scalars['ID']>;
};

export enum GQLDiscussionsCommentSourcesEnum {
  Web = 'web',
  Chatbot = 'chatbot',
  MobileApp = 'mobile_app',
  DiscRepo = 'disc_repo',
  Unknown = 'unknown'
}



export type GQLEnergyLabel = {
  __typename?: 'EnergyLabel';
  label: Scalars['String'];
  class: Scalars['String'];
};

export type GQLEnergyLabelMedia = {
  __typename?: 'EnergyLabelMedia';
  mimeType: Scalars['String'];
  mediaId: Scalars['String'];
};

export type GQLEshopBranch = {
  __typename?: 'EshopBranch';
  id: Scalars['Int'];
  name: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  branchAddress: GQLEshopBranchAddress;
  websiteLink?: Maybe<Scalars['String']>;
};

export type GQLEshopBranchAddress = {
  __typename?: 'EshopBranchAddress';
  branchStreet?: Maybe<Scalars['String']>;
  branchHouseNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
};

export type GQLEshopBranchGroup = {
  __typename?: 'EshopBranchGroup';
  branches: Array<GQLEshopBranch>;
  pupTransportGroupCode: Scalars['String'];
};

export enum GQLEstimatedDeliveriesType {
  Ede = 'EDE',
  Eds = 'EDS'
}

export type GQLEstimatedDelivery = {
  __typename?: 'EstimatedDelivery';
  home: Array<Maybe<GQLHomeDeliveryItem>>;
  pup: Array<Maybe<GQLDeliveryItem>>;
  cac: Array<Maybe<GQLDeliveryItem>>;
  containsSmartDelivery?: Maybe<Scalars['Boolean']>;
};

export enum GQLExceptionCodes {
  TooManyRequests = 'TOO_MANY_REQUESTS',
  ValidationError = 'VALIDATION_ERROR',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  NotFound = 'NOT_FOUND',
  NotAvailable = 'NOT_AVAILABLE',
  Forbidden = 'FORBIDDEN',
  Conflict = 'CONFLICT',
  BadRequest = 'BAD_REQUEST'
}

export type GQLExceptionEnums = {
  __typename?: 'ExceptionEnums';
  scopes: Array<GQLExceptionScopes>;
  codes: Array<GQLExceptionCodes>;
};

export enum GQLExceptionScopes {
  Product = 'Product',
  Customer = 'Customer',
  ProductReview = 'ProductReview',
  Order = 'Order',
  DigitalContent = 'DigitalContent',
  Club = 'Club',
  Messaging = 'Messaging',
  Wishlist = 'Wishlist',
  RmaContent = 'RmaContent',
  Cart = 'Cart',
  Checkout = 'Checkout'
}

export type GQLFilterCategory = GQLCategory & {
  __typename?: 'FilterCategory';
  id: Scalars['ID'];
  footer?: Maybe<Array<GQLFooter>>;
  shoppingWizard?: Maybe<GQLShoppingWizardPreview>;
  title: Scalars['String'];
  titleFull?: Maybe<Scalars['String']>;
  titleStructured?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['Int']>;
  secondaryMediaId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  metaDescription?: Maybe<Scalars['String']>;
  metaKeywords?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  howto?: Maybe<Scalars['String']>;
  productOrder?: Maybe<Scalars['String']>;
  breadcrumbs: Array<GQLCategory>;
  children: Array<GQLCategory>;
  isRepresentative: Scalars['Boolean'];
  isMainTile: Scalars['Boolean'];
  menu: Array<GQLMixedChildren>;
  typeVersion: Scalars['Int'];
  isTrendy: Scalars['Boolean'];
  indexSeo?: Maybe<Scalars['Boolean']>;
  giftHelperUrl?: Maybe<Scalars['String']>;
  giftHelperTitle?: Maybe<Scalars['String']>;
  filterCategoryParams?: Maybe<GQLFilterCategoryParams>;
  coupon?: Maybe<GQLCoupon>;
};


export type GQLFilterCategoryDescriptionArgs = {
  normalizeHtml?: Maybe<GQLNormalizeInput>;
};


export type GQLFilterCategoryChildrenArgs = {
  sort?: Maybe<GQLCategorySort>;
  visibility?: Maybe<GQLCategoryVisibility>;
};


export type GQLFilterCategoryMenuArgs = {
  usedFilters?: Maybe<Array<GQLProductFilterValueInput>>;
};

export type GQLFilterCategoryMenuContraints = {
  __typename?: 'FilterCategoryMenuContraints';
  paramId: Scalars['String'];
  operator: Scalars['String'];
  value1: Scalars['String'];
  value2?: Maybe<Scalars['String']>;
  class: Scalars['Int'];
};

export type GQLFilterCategoryParams = {
  __typename?: 'FilterCategoryParams';
  price?: Maybe<GQLFilterCategoryParamsPrice>;
  labels: Array<Scalars['String']>;
  brandsConstraints: Array<Scalars['String']>;
  productPartnerIds: Array<Scalars['String']>;
  menuConstraints: Array<GQLFilterCategoryMenuContraints>;
};

export type GQLFilterCategoryParamsPrice = {
  __typename?: 'FilterCategoryParamsPrice';
  min?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
};

export enum GQLFinancialOfferProviders {
  Paylight = 'PAYLIGHT',
  Pfc = 'PFC'
}

export type GQLFinancialOfferResult = GQLPfcFinancialOfferResult | GQLPaylightFinancialOfferResult;

export type GQLFinishResetPasswordInput = {
  hash: Scalars['String'];
  password: Scalars['String'];
};

export type GQLFooter = {
  __typename?: 'Footer';
  type?: Maybe<Scalars['String']>;
  links: Array<GQLFooterLinks>;
};

export type GQLFooterLinks = {
  __typename?: 'FooterLinks';
  urlkey?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  urlType?: Maybe<Scalars['String']>;
  urlParams?: Maybe<Scalars['String']>;
};

export type GQLFrmCompanyRegistrationData = {
  name: Scalars['SanitizedString'];
  email: Scalars['EmailAddress'];
  companyName: Scalars['SanitizedString'];
};

export type GQLFrmContactUsData = {
  name: Scalars['SanitizedString'];
  email: Scalars['EmailAddress'];
  phone: Scalars['SanitizedString'];
  subject: Scalars['SanitizedString'];
  message: Scalars['SanitizedString'];
};

export type GQLGetAllegroLinkQuery = {
  pmdId: Scalars['String'];
};

export type GQLGetCampaignQueryInput = {
  previewHash?: Maybe<Scalars['String']>;
  abTestVariant?: Maybe<Scalars['String']>;
  abTestCookies?: Maybe<Array<GQLAbTestCookie>>;
  bannersPage?: Maybe<Scalars['String']>;
  isMobile?: Maybe<Scalars['Boolean']>;
};

export type GQLGetCategoryQueryInput = {
  isMobile?: Maybe<Scalars['Boolean']>;
};

export type GQLGetContentQuery = {
  useSpaVersion?: Maybe<Scalars['Boolean']>;
};

export type GQLGetFiltersQueryInput = {
  categoryUrlKey?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  brandUrl?: Maybe<Scalars['String']>;
  partnerUrl?: Maybe<Scalars['String']>;
  parameter?: Maybe<GQLSiSParameterInput>;
  listLabel?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<GQLProductFilterValueInput>>;
  allFilters?: Maybe<Scalars['Boolean']>;
};

export type GQLGetFinancialOffersInput = {
  variantId?: Maybe<Scalars['ID']>;
  bonussetId?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  productTypeId?: Maybe<Scalars['String']>;
  materialType?: Maybe<Scalars['String']>;
  isMarketplace?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type GQLGetInstallmentsCalculationInput = {
  shopId: Scalars['String'];
  paymentMethodId: Scalars['String'];
  price: Scalars['Float'];
  installmentCount?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Float']>;
  productCode?: Maybe<Scalars['String']>;
  productTypeId?: Maybe<Scalars['String']>;
  insuranceCode?: Maybe<Scalars['String']>;
  options?: Maybe<GQLOption>;
  products: Array<GQLInstallmentsProduct>;
};

export type GQLGetInstallmentsInsurancesInput = {
  shopId: Scalars['String'];
  paymentMethodId: Scalars['String'];
};

export type GQLGetInstallmentsSliderInput = {
  shopId: Scalars['String'];
  paymentMethodId: Scalars['String'];
  price: Scalars['Float'];
  products: Array<GQLInstallmentsProduct>;
  options?: Maybe<GQLOption>;
};

export type GQLGetInstallmentsTilesInput = {
  shopId: Scalars['String'];
  paymentMethodId: Scalars['String'];
  price: Scalars['Float'];
  products: Array<GQLInstallmentsProduct>;
  options?: Maybe<GQLOption>;
};

export type GQLGetPageBannerBannersQueryInput = {
  positions: Array<Scalars['Int']>;
};

export type GQLGetProductVariantParametersDetail = {
  __typename?: 'GetProductVariantParametersDetail';
  variantParameter1?: Maybe<Scalars['String']>;
  variantParameter2?: Maybe<Scalars['String']>;
  variantParameters: Array<GQLProductVariantParametersDetailFull>;
};

export type GQLGetReviewFilter = {
  withMediaTypes?: Maybe<Array<Scalars['String']>>;
  rankFrom?: Maybe<Scalars['Int']>;
  rankTo?: Maybe<Scalars['Int']>;
};

export type GQLGetReviewSort = {
  field: Scalars['String'];
  order: GQLOrderType;
};

export type GQLGetSearchQueryInput = {
  /** Default pagination is set - limit 40 offset 0 */
  pagination?: Maybe<GQLProductCollectionPaginationInput>;
  productSorting?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<GQLProductFilterValueInput>>;
  /** Default value is 20 */
  maxNavigationItems?: Maybe<Scalars['Int']>;
  pageUrl: Scalars['String'];
  isMobile: Scalars['Boolean'];
  useQuRedir?: Maybe<Scalars['Boolean']>;
};

export type GQLGiftDetails = {
  __typename?: 'GiftDetails';
  giftId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  variants: Array<GQLGiftDetailsVariant>;
};

export type GQLGiftDetailsVariant = {
  __typename?: 'GiftDetailsVariant';
  validTo: Scalars['DateTime'];
  validFrom: Scalars['DateTime'];
  available: Scalars['Boolean'];
  count: Scalars['Int'];
  variantTitle: Scalars['String'];
  variant?: Maybe<GQLProductVariant>;
  product?: Maybe<GQLProduct>;
};

export type GQLGlossary = {
  __typename?: 'Glossary';
  term: Scalars['String'];
  active: Scalars['Boolean'];
};

export type GQLGlossaryTerm = {
  __typename?: 'GlossaryTerm';
  active: Scalars['Boolean'];
  body?: Maybe<Scalars['String']>;
};


export type GQLHeaderBanner = {
  __typename?: 'HeaderBanner';
  bannerId: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  urlNewWindow: Scalars['Boolean'];
  mediaId?: Maybe<Scalars['String']>;
  mobileMediaId?: Maybe<Scalars['String']>;
  headerText?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundRepeat: Scalars['Boolean'];
  gaTag?: Maybe<Scalars['String']>;
};



export type GQLHomeDeliveryItem = {
  __typename?: 'HomeDeliveryItem';
  name?: Maybe<Scalars['String']>;
  deliveryFrom?: Maybe<Scalars['String']>;
  deliveryTo?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  totalPrice: Scalars['Float'];
  closeTime?: Maybe<Scalars['DateTime']>;
  priceReasons?: Maybe<Array<Maybe<GQLDeliveryItemPriceReason>>>;
};




export type GQLIBaseSiSResponse = {
  title?: Maybe<Scalars['String']>;
  breadcrumbs: Array<GQLCategory>;
  bestSellers: Array<GQLProduct>;
  productCollection?: Maybe<GQLProductCollection>;
  category?: Maybe<GQLContentCategory>;
};


export type GQLIBaseSiSResponseBestSellersArgs = {
  query?: Maybe<GQLBestSellersQueryInput>;
};


export type GQLIBaseSiSResponseProductCollectionArgs = {
  query?: Maybe<GQLProductCollectionQueryInput>;
};

export type GQLIItemAutocompleteBase = {
  id: Scalars['ID'];
  title: Scalars['String'];
  /**  should be 'category', 'category_with_brand', 'brand', 'signpost', 'licence', 'param'  */
  type: Scalars['String'];
  urlKey: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
};

export type GQLIMenuBanner = {
  bannerId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  urlNewWindow: Scalars['Boolean'];
  mediaId: Scalars['String'];
  gaTag?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
};

export type GQLInfoBanner = GQLInfoImageBanner | GQLInfoPointsBanner;

export type GQLInfoBannerBase = {
  bannerId: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  urlNewWindow: Scalars['Boolean'];
  closable: Scalars['Boolean'];
  closeButtonColor?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  alignLeft: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  subheading?: Maybe<Scalars['String']>;
  gaTag?: Maybe<Scalars['String']>;
};

export type GQLInfoBannerImage = {
  __typename?: 'InfoBannerImage';
  bannerId: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  urlNewWindow: Scalars['Boolean'];
  mediaId?: Maybe<Scalars['String']>;
  mobileMediaId?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
};

export type GQLInfoBannerPoint = {
  __typename?: 'InfoBannerPoint';
  url?: Maybe<Scalars['String']>;
  urlNewWindow: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
};

export type GQLInfoImageBanner = GQLInfoBannerBase & {
  __typename?: 'InfoImageBanner';
  bannerId: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  urlNewWindow: Scalars['Boolean'];
  closable: Scalars['Boolean'];
  closeButtonColor?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  alignLeft: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  subheading?: Maybe<Scalars['String']>;
  gaTag?: Maybe<Scalars['String']>;
  autoplayDuration?: Maybe<Scalars['String']>;
  images?: Maybe<Array<GQLInfoBannerImage>>;
};

export type GQLInfoPointsBanner = GQLInfoBannerBase & {
  __typename?: 'InfoPointsBanner';
  bannerId: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  urlNewWindow: Scalars['Boolean'];
  closable: Scalars['Boolean'];
  closeButtonColor?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  alignLeft: Scalars['Boolean'];
  heading?: Maybe<Scalars['String']>;
  subheading?: Maybe<Scalars['String']>;
  gaTag?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  mobileMediaId?: Maybe<Scalars['String']>;
  points?: Maybe<Array<GQLInfoBannerPoint>>;
};

export type GQLInitResetPasswordInput = {
  email: Scalars['String'];
};

export type GQLInstallmentCalculation = {
  __typename?: 'InstallmentCalculation';
  installmentAmount: Scalars['Float'];
  installmentCount: Scalars['Int'];
  totalAmount?: Maybe<Scalars['Float']>;
  annualInterestRate?: Maybe<Scalars['Float']>;
  depositAmount?: Maybe<Scalars['Float']>;
  apr?: Maybe<Scalars['Float']>;
  productCode?: Maybe<Scalars['String']>;
  legalLine?: Maybe<Scalars['String']>;
  insuranceCode?: Maybe<Scalars['String']>;
};

export type GQLInstallmentInsurance = {
  __typename?: 'InstallmentInsurance';
  title: Scalars['String'];
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type GQLInstallmentItem = {
  __typename?: 'InstallmentItem';
  title: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  installmentCount: Scalars['Int'];
  calculation?: Maybe<GQLInstallmentCalculation>;
};

export type GQLInstallmentsCalculationResult = {
  __typename?: 'InstallmentsCalculationResult';
  totalAmount: Scalars['Float'];
  installmentAmount: Scalars['Float'];
  installmentCount: Scalars['Int'];
  annualInterestRate: Scalars['Float'];
  depositAmount: Scalars['Float'];
  apr: Scalars['Float'];
  productCode?: Maybe<Scalars['String']>;
  legalLine?: Maybe<Scalars['String']>;
  insuranceCode?: Maybe<Scalars['String']>;
};

export type GQLInstallmentsInsurancesResult = {
  __typename?: 'InstallmentsInsurancesResult';
  insurances: Array<GQLInstallmentInsurance>;
};

export type GQLInstallmentsProduct = {
  id: Scalars['ID'];
  title: Scalars['String'];
  unitPrice: Scalars['Float'];
  quantity: Scalars['Int'];
  productTypeId: Scalars['String'];
  brandId: Scalars['String'];
  entityId: Scalars['String'];
  labels: Array<Scalars['String']>;
};

export type GQLInstallmentsSliderResult = {
  __typename?: 'InstallmentsSliderResult';
  title: Scalars['String'];
  steps: Array<GQLInstallmentItem>;
};

export type GQLInstallmentsTilesResult = {
  __typename?: 'InstallmentsTilesResult';
  tiles?: Maybe<Array<GQLInstallmentItem>>;
};

export type GQLIProductVariantParametersDetail = {
  entityId: Scalars['String'];
  parameterId: Scalars['String'];
  valueId: Scalars['String'];
  value: Scalars['String'];
  url: Scalars['String'];
  price: Scalars['Float'];
  available: Scalars['Boolean'];
  mediaId: Scalars['Int'];
};





export type GQLItemAutocomplete = GQLIItemAutocompleteBase & {
  __typename?: 'ItemAutocomplete';
  id: Scalars['ID'];
  title: Scalars['String'];
  /** should be 'brand', 'signpost', 'licence' */
  type: Scalars['String'];
  urlKey: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
};

export type GQLItemsAutocomplete = GQLCategoryAutocomplete | GQLItemAutocomplete;




export type GQLLabelsData = {
  __typename?: 'LabelsData';
  id: Scalars['String'];
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  coupon?: Maybe<GQLCoupon>;
};


export enum GQLLicenceKeyStatus {
  Created = 'CREATED',
  Processed = 'PROCESSED'
}

export type GQLLinkedCategory = GQLCategory & {
  __typename?: 'LinkedCategory';
  id: Scalars['ID'];
  footer?: Maybe<Array<GQLFooter>>;
  shoppingWizard?: Maybe<GQLShoppingWizardPreview>;
  title: Scalars['String'];
  titleFull?: Maybe<Scalars['String']>;
  titleStructured?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['Int']>;
  secondaryMediaId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  metaDescription?: Maybe<Scalars['String']>;
  metaKeywords?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  howto?: Maybe<Scalars['String']>;
  productOrder?: Maybe<Scalars['String']>;
  breadcrumbs: Array<GQLCategory>;
  children: Array<GQLCategory>;
  linkedWith: GQLCategory;
  isRepresentative: Scalars['Boolean'];
  isMainTile: Scalars['Boolean'];
  menu: Array<GQLMixedChildren>;
  typeVersion: Scalars['Int'];
  isTrendy: Scalars['Boolean'];
  indexSeo?: Maybe<Scalars['Boolean']>;
  giftHelperUrl?: Maybe<Scalars['String']>;
  giftHelperTitle?: Maybe<Scalars['String']>;
  coupon?: Maybe<GQLCoupon>;
};


export type GQLLinkedCategoryDescriptionArgs = {
  normalizeHtml?: Maybe<GQLNormalizeInput>;
};


export type GQLLinkedCategoryChildrenArgs = {
  sort?: Maybe<GQLCategorySort>;
  visibility?: Maybe<GQLCategoryVisibility>;
};


export type GQLLinkedCategoryMenuArgs = {
  usedFilters?: Maybe<Array<GQLProductFilterValueInput>>;
};

export type GQLLinkedProducts = {
  __typename?: 'LinkedProducts';
  multipricing?: Maybe<GQLMultipricingBox>;
  bazaar?: Maybe<GQLBazaarBox>;
};

export type GQLList = {
  __typename?: 'List';
  title: Scalars['String'];
  urlKey: Scalars['String'];
  productCollection?: Maybe<GQLProductCollection>;
  metaDescription: Scalars['String'];
  metaKeywords: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};


export type GQLListProductCollectionArgs = {
  query: GQLListProductCollectionQueryInput;
};

export type GQLListProductCollectionQueryInput = {
  pagination?: Maybe<GQLProductCollectionPaginationInput>;
  productSorting?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<GQLProductFilterValueInput>>;
  sortVersion?: Maybe<Scalars['String']>;
  isMobile?: Maybe<Scalars['Boolean']>;
};








export type GQLMallService = {
  __typename?: 'MallService';
  image?: Maybe<Array<Scalars['String']>>;
  text: Scalars['String'];
  tooltip: Scalars['String'];
};

export type GQLMallSmartConfig = {
  __typename?: 'MallSmartConfig';
  productId?: Maybe<Scalars['ID']>;
  product?: Maybe<GQLProduct>;
  clubId?: Maybe<Scalars['ID']>;
  discount?: Maybe<GQLMallSmartDiscount>;
};

export type GQLMallSmartDiscount = {
  __typename?: 'MallSmartDiscount';
  codeVoucher?: Maybe<Scalars['String']>;
  priceAfterVoucher?: Maybe<Scalars['Float']>;
  priceAfterVoucherCurrency?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type GQLManualAddressVerificationInput = {
  oib: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type GQLMarketplaceProductData = {
  __typename?: 'MarketplaceProductData';
  marketplacePartnerTitle: Scalars['String'];
  marketplacePartnerId: Scalars['String'];
  marketplacePartnerUrl?: Maybe<Scalars['String']>;
};

export type GQLMarketplaceVariantData = {
  __typename?: 'MarketplaceVariantData';
  isMarketplace: Scalars['Boolean'];
  closeTime?: Maybe<Scalars['String']>;
  deliveryDelay?: Maybe<Scalars['Int']>;
  availabilityDelay?: Maybe<Scalars['Int']>;
  partnerId?: Maybe<Scalars['String']>;
};

export type GQLMenu = {
  __typename?: 'Menu';
  meta?: Maybe<GQLMenuMeta>;
  data: Array<GQLMenuItem>;
};


export type GQLMenuDataArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type GQLMenuAbTest = {
  __typename?: 'MenuAbTest';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type GQLMenuBanner = GQLIMenuBanner & {
  __typename?: 'MenuBanner';
  bannerId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  urlNewWindow: Scalars['Boolean'];
  mediaId: Scalars['String'];
  gaTag?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
};

/** menu identification from NAVI */
export type GQLMenuId = {
  menuType: Scalars['String'];
  /**  if menuVersion was not set, the default version of concrete menuType will be returned. This parameter will win if combination of params will be setted.  */
  menuVersion?: Maybe<Scalars['String']>;
  /**  id of abTestVersion, which will be returned. This parameter wins over default menu version but not over concrete version  */
  abTestVersion?: Maybe<Scalars['String']>;
};

export enum GQLMenuImageFormat {
  Image = 'IMAGE',
  Svg = 'SVG'
}

export type GQLMenuItem = {
  __typename?: 'MenuItem';
  id: Scalars['ID'];
  name: Scalars['String'];
  banners?: Maybe<GQLMenuItemBanners>;
  image?: Maybe<GQLMenuItemImage>;
  icon?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  customData?: Maybe<Scalars['Object']>;
  hasChildren: Scalars['Boolean'];
  children?: Maybe<Array<GQLMenuItem>>;
};

export type GQLMenuItemBanners = {
  __typename?: 'MenuItemBanners';
  pageId?: Maybe<Scalars['String']>;
  banner?: Maybe<GQLMenuMainBanner>;
  brandBanners?: Maybe<Array<GQLMenuBanner>>;
};

export type GQLMenuItemImage = {
  __typename?: 'MenuItemImage';
  imageId: Scalars['String'];
  format: GQLMenuImageFormat;
};

export type GQLMenuMainBanner = GQLIMenuBanner & {
  __typename?: 'MenuMainBanner';
  bannerId: Scalars['ID'];
  type: GQLMenuMainBannerType;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  urlNewWindow: Scalars['Boolean'];
  mediaId: Scalars['String'];
  gaTag?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
};

export enum GQLMenuMainBannerType {
  Full = 'full',
  Half = 'half'
}

export type GQLMenuMeta = {
  __typename?: 'MenuMeta';
  allAbTests: Array<Scalars['String']>;
};

export type GQLMixedChildren = GQLFilterCategory | GQLLinkedCategory | GQLProductCategory | GQLUnknownCategory | GQLContentCategory | GQLSignPostCategory | GQLSearchResultNavigationItems;

export enum GQLMobileErrorDisplayType {
  Alert = 'ALERT',
  ScreenMessage = 'SCREEN_MESSAGE'
}

export type GQLMultipricingBox = {
  __typename?: 'MultipricingBox';
  ids: Array<Scalars['ID']>;
  lowestPrice: Scalars['Float'];
  products: Array<GQLProduct>;
};

export type GQLMutation = {
  __typename?: 'Mutation';
  frmCreateCompanyRegistration?: Maybe<Scalars['Void']>;
  frmContactUs?: Maybe<Scalars['Void']>;
  revalidateContentById?: Maybe<Scalars['Void']>;
  revalidateGlossayTerm?: Maybe<Scalars['Void']>;
  revalidateGlossaryList?: Maybe<Scalars['Void']>;
  /**  Authenticated mutation, x-user-id header is mandatory. Delete wishlist item by id, which is composed - whishlist id and whislist item id.  */
  addProductDiscussionsComment?: Maybe<Scalars['Void']>;
  addReviewUsefulness: GQLReviewUsefulness;
  createProductReview: GQLProductReview;
  updateProductReview: GQLProductReview;
  /**  Authenticated mutation, x-user-id header is mandatory. Delete wishlist item by id, which is composed - whishlist id and whislist item id.  */
  deleteWishListItem?: Maybe<GQLWishList>;
  /**  Authenticated mutation, x-user-id header is mandatory. Creates new wishlist item  */
  createWishListItem?: Maybe<GQLWishList>;
  /**  Authenticated mutation, x-user-id header is mandatory. Updates wishlist item.  */
  updateWishListItem?: Maybe<GQLWishList>;
  /**  Authenticated mutation, x-user-id header is mandatory. Create new wishlist  */
  createWishList?: Maybe<GQLWishList>;
  /**  Authenticated mutation, x-user-id header is mandatory. Updates whishlist  */
  updateWishList?: Maybe<GQLWishList>;
  /**  Authenticated mutation, x-user-id header is mandatory. Deletes whishlist  */
  deleteWishList?: Maybe<Scalars['Boolean']>;
  createShippingAddress?: Maybe<GQLShippingAddress>;
  createBillingAddress?: Maybe<GQLBillingAddress>;
  updateShippingAddress?: Maybe<Scalars['Void']>;
  updateBillingAddress?: Maybe<Scalars['Void']>;
  updateMe?: Maybe<Scalars['Void']>;
  deleteShippingAddress?: Maybe<Scalars['Void']>;
  deleteBillingAddress?: Maybe<Scalars['Void']>;
  deleteMyPaymentCard?: Maybe<Scalars['Void']>;
  changePassword?: Maybe<Scalars['Void']>;
  initChangeEmail?: Maybe<Scalars['Void']>;
  requestManualAddressVerification?: Maybe<Scalars['Void']>;
  finishChangeEmail?: Maybe<Scalars['Void']>;
  initAccountDeactivation?: Maybe<Scalars['Void']>;
  finishAccountDeactivation?: Maybe<Scalars['Void']>;
  createCustomerConsent: GQLUser;
  initResetPassword?: Maybe<Scalars['Void']>;
  finishResetPassword?: Maybe<Scalars['Void']>;
  finishReviewEmailDeactivation?: Maybe<Scalars['Void']>;
  /** Authenticated query, x-user-id header is mandatory. */
  beginDeliveryPersonalPickup?: Maybe<GQLBeginDeliveryPersonalPickup>;
  changePayment?: Maybe<Scalars['Boolean']>;
  cancelAdvancePayment?: Maybe<Scalars['Boolean']>;
  /** Authenticated query, x-user-id and x-shop-id headers are mandatory. */
  requestDigitalContentApiKey?: Maybe<GQLDigitalContentAuthorizedRequest>;
  /** Authenticated query, x-user-id and x-shop-id headers are mandatory. */
  authorizeDigitalContentApiKey?: Maybe<Scalars['Boolean']>;
  clubSubscribe?: Maybe<GQLClubSubscriptionStatus>;
  clubUnsubscribe?: Maybe<Scalars['Void']>;
  clubSaveForm?: Maybe<Scalars['Void']>;
  clubDeleteForm?: Maybe<Scalars['Void']>;
  addArticle: GQLCartPreview;
  updateArticle: GQLCartPreview;
  deleteArticle: GQLCartPreview;
  applyDiscountCode: GQLCartPreview;
  removeDiscountCode: GQLCartPreview;
  removeCartIdByUserId?: Maybe<Scalars['Void']>;
  createOrder?: Maybe<GQLCheckoutOrder>;
  updateAppNotifications?: Maybe<GQLAppNotifications>;
  createBillingAddressFromCompanyId?: Maybe<GQLCreateBillingAddressFromCompanyIdResponse>;
  createWatchdog: GQLWatchdogCollection;
  deleteWatchdog: GQLWatchdogCollection;
  confirmWatchdog?: Maybe<GQLWatchdog>;
  /** Shop ID & User ID are taken from header x-shop-id & x-user-id. */
  deletePaymentCard?: Maybe<Scalars['Void']>;
  /**  Currently only available for CSOB (1.9) payments. Shop ID taken from header.  */
  processPayment?: Maybe<GQLPaymentInfoResult>;
  /**  ShopId is required. If possible, it's taken from 'X-Shop-Id' header, but possible to supply as argument too  */
  repayPayment: GQLRepayResponse;
};


export type GQLMutationFrmCreateCompanyRegistrationArgs = {
  data: GQLFrmCompanyRegistrationData;
  captchaToken: Scalars['String'];
};


export type GQLMutationFrmContactUsArgs = {
  data: GQLFrmContactUsData;
  captchaToken: Scalars['String'];
};


export type GQLMutationRevalidateContentByIdArgs = {
  id: Scalars['ID'];
};


export type GQLMutationRevalidateGlossayTermArgs = {
  term: Scalars['String'];
};


export type GQLMutationAddProductDiscussionsCommentArgs = {
  productId: Scalars['ID'];
  comment: GQLDiscussionsCommentInput;
  variantId?: Maybe<Scalars['ID']>;
};


export type GQLMutationAddReviewUsefulnessArgs = {
  reviewId: Scalars['ID'];
  usefulness: GQLUsefulnessInput;
};


export type GQLMutationCreateProductReviewArgs = {
  review: GQLCreateProductReviewInput;
};


export type GQLMutationUpdateProductReviewArgs = {
  review: GQLUpdateProductReviewInput;
};


export type GQLMutationDeleteWishListItemArgs = {
  wishListItemId?: Maybe<GQLWishListItemIdInput>;
};


export type GQLMutationCreateWishListItemArgs = {
  wishList?: Maybe<GQLWishListItemInput>;
};


export type GQLMutationUpdateWishListItemArgs = {
  wishListItemId?: Maybe<GQLWishListItemIdInput>;
  wishList?: Maybe<GQLWishListItemUpdateInput>;
};


export type GQLMutationCreateWishListArgs = {
  wishList?: Maybe<GQLWishListInput>;
};


export type GQLMutationUpdateWishListArgs = {
  wishListId?: Maybe<Scalars['ID']>;
  whishList?: Maybe<GQLWishListInput>;
};


export type GQLMutationDeleteWishListArgs = {
  wishListId?: Maybe<Scalars['ID']>;
};


export type GQLMutationCreateShippingAddressArgs = {
  address: GQLCreateShippingAddressInput;
};


export type GQLMutationCreateBillingAddressArgs = {
  address: GQLCreateBillingAddressInput;
};


export type GQLMutationUpdateShippingAddressArgs = {
  address: GQLUpdateShippingAddressInput;
};


export type GQLMutationUpdateBillingAddressArgs = {
  address: GQLUpdateBillingAddressInput;
};


export type GQLMutationUpdateMeArgs = {
  customer: GQLUpdateMeInput;
};


export type GQLMutationDeleteShippingAddressArgs = {
  address: GQLDeleteAddressInput;
};


export type GQLMutationDeleteBillingAddressArgs = {
  address: GQLDeleteAddressInput;
};


export type GQLMutationDeleteMyPaymentCardArgs = {
  id: Scalars['ID'];
};


export type GQLMutationChangePasswordArgs = {
  data: GQLChangePasswordInput;
};


export type GQLMutationInitChangeEmailArgs = {
  data: GQLChangeEmailInput;
};


export type GQLMutationRequestManualAddressVerificationArgs = {
  data: GQLManualAddressVerificationInput;
};


export type GQLMutationFinishChangeEmailArgs = {
  hash: Scalars['String'];
};


export type GQLMutationFinishAccountDeactivationArgs = {
  hash: Scalars['String'];
};


export type GQLMutationCreateCustomerConsentArgs = {
  consent: GQLCreateCustomerConsentInput;
};


export type GQLMutationInitResetPasswordArgs = {
  data: GQLInitResetPasswordInput;
};


export type GQLMutationFinishResetPasswordArgs = {
  data: GQLFinishResetPasswordInput;
};


export type GQLMutationFinishReviewEmailDeactivationArgs = {
  hash: Scalars['String'];
};


export type GQLMutationBeginDeliveryPersonalPickupArgs = {
  orderId: Scalars['ID'];
  deliveryId: Scalars['ID'];
};


export type GQLMutationChangePaymentArgs = {
  orderId: Scalars['ID'];
  oldPayment: GQLOrderPaymentInput;
  newPayment: GQLOrderPaymentInput;
};


export type GQLMutationCancelAdvancePaymentArgs = {
  orderId: Scalars['ID'];
};


export type GQLMutationRequestDigitalContentApiKeyArgs = {
  phone: Scalars['String'];
};


export type GQLMutationAuthorizeDigitalContentApiKeyArgs = {
  authorizationId: Scalars['String'];
  authorizationCode: Scalars['String'];
};


export type GQLMutationClubSubscribeArgs = {
  clubId: Scalars['ID'];
  email: Scalars['String'];
};


export type GQLMutationClubUnsubscribeArgs = {
  clubId: Scalars['ID'];
};


export type GQLMutationClubSaveFormArgs = {
  clubId: Scalars['ID'];
  email: Scalars['String'];
  formData: Array<Scalars['Object']>;
};


export type GQLMutationClubDeleteFormArgs = {
  clubId: Scalars['ID'];
};


export type GQLMutationAddArticleArgs = {
  article: GQLCartAddInput;
};


export type GQLMutationUpdateArticleArgs = {
  article: GQLCartUpdateInput;
};


export type GQLMutationDeleteArticleArgs = {
  article: GQLCartDeleteInput;
};


export type GQLMutationApplyDiscountCodeArgs = {
  code: Scalars['String'];
};


export type GQLMutationRemoveDiscountCodeArgs = {
  code: Scalars['String'];
};


export type GQLMutationRemoveCartIdByUserIdArgs = {
  userId: Scalars['Int'];
};


export type GQLMutationUpdateAppNotificationsArgs = {
  notifications: GQLUpdateAppNotificationsInput;
};


export type GQLMutationCreateBillingAddressFromCompanyIdArgs = {
  input: GQLCreateBillingAddressFromCompanyIdInput;
};


export type GQLMutationCreateWatchdogArgs = {
  watchdog: GQLWatchdogInput;
};


export type GQLMutationDeleteWatchdogArgs = {
  id: Scalars['ID'];
};


export type GQLMutationConfirmWatchdogArgs = {
  hash: Scalars['String'];
};


export type GQLMutationDeletePaymentCardArgs = {
  id: Scalars['ID'];
};


export type GQLMutationProcessPaymentArgs = {
  input: GQLProcessPaymentInput;
};


export type GQLMutationRepayPaymentArgs = {
  paymentId: Scalars['String'];
  shopId?: Maybe<Scalars['String']>;
};



export type GQLNoIndexParam = {
  __typename?: 'NoIndexParam';
  paramId: Scalars['String'];
  values: Array<Scalars['String']>;
};






export type GQLNormalizeInput = {
  useBaseHtmlTags: Scalars['Boolean'];
  allowedCustomTags?: Maybe<Array<Scalars['String']>>;
};



export type GQLOption = {
  installmentCount?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['Float']>;
  productCode?: Maybe<Scalars['String']>;
  insuranceCode?: Maybe<Scalars['String']>;
  viewType?: Maybe<Scalars['String']>;
};

export type GQLOrder = {
  __typename?: 'Order';
  id: Scalars['ID'];
  chatbotHash: Scalars['String'];
  currency: Scalars['String'];
  created: Scalars['DateTime'];
  status?: Maybe<GQLOrderStatus>;
  customer: GQLOrderCustomer;
  shippingAddress: GQLShippingAddress;
  billingAddress: GQLBillingAddress;
  items: Array<GQLOrderItem>;
  deliveries: Array<GQLOrderDelivery>;
  payments: Array<GQLOrderPayment>;
  total: GQLOrderTotal;
  changeableData: GQLOrderChangeableData;
  qrCode?: Maybe<Scalars['String']>;
  resolvedPayment: GQLOrderResolvedPayment;
  paymentInformation: GQLOrderPaymentInformation;
};

export type GQLOrderChangeableData = {
  __typename?: 'OrderChangeableData';
  ordCanc: Scalars['Boolean'];
  zalCanc: Scalars['Boolean'];
  billing: Scalars['Boolean'];
  shipping: Scalars['Boolean'];
};

export type GQLOrderCollection = {
  __typename?: 'OrderCollection';
  items: Array<GQLOrder>;
  hits: Scalars['Int'];
};

export type GQLOrderCustomer = {
  __typename?: 'OrderCustomer';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  street: Scalars['String'];
  city: Scalars['String'];
  zip: Scalars['String'];
  phone: Scalars['String'];
  email: Scalars['String'];
};

export type GQLOrderDelivery = {
  __typename?: 'OrderDelivery';
  deliveryId: Scalars['ID'];
  orderId: Scalars['String'];
  totalPrice: Scalars['Float'];
  amount?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['DateTime']>;
  payments: Array<GQLOrderPayment>;
  readyForHandover?: Maybe<GQLOrderReadyForHandover>;
  type?: Maybe<Scalars['String']>;
  status?: Maybe<GQLOrderStatus>;
  outlet?: Maybe<GQLOrderOutlet>;
  services?: Maybe<Array<Maybe<GQLOrderDeliveryService>>>;
  customerDeliveryDate?: Maybe<Scalars['DateTime']>;
  lastCustomerDeliveryDate?: Maybe<Scalars['DateTime']>;
  lastPickupDate?: Maybe<Scalars['DateTime']>;
  deliveryType: Scalars['String'];
  code: Scalars['String'];
  invoiceId?: Maybe<Scalars['ID']>;
  packageGroupId?: Maybe<Scalars['String']>;
  methodId?: Maybe<Scalars['String']>;
  transportId?: Maybe<Scalars['String']>;
  timeline?: Maybe<GQLOrderDeliveryTimeline>;
  tracking: Array<GQLOrderTracking>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Scalars['String']>;
  isMarketplace?: Maybe<Scalars['Boolean']>;
  isPup?: Maybe<Scalars['Boolean']>;
  parcelTrackingUrl?: Maybe<Scalars['String']>;
};

export type GQLOrderDeliveryService = {
  __typename?: 'OrderDeliveryService';
  serviceId: Scalars['ID'];
  price: Scalars['Float'];
  amount: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export type GQLOrderDeliveryTimeline = {
  __typename?: 'OrderDeliveryTimeline';
  steps?: Maybe<Array<Maybe<GQLOrderDeliveryTimelineStep>>>;
  currentState?: Maybe<GQLOrderDeliveryTimelineCurrentState>;
};

export type GQLOrderDeliveryTimelineCurrentState = {
  __typename?: 'OrderDeliveryTimelineCurrentState';
  state: GQLOrderDeliveryTimelineState;
  title?: Maybe<GQLOrderDeliveryTimelineStepTitle>;
  subtitles?: Maybe<Array<Maybe<GQLOrderDeliveryTimelineStepSubtitle>>>;
  params?: Maybe<GQLOrderDeliveryTimelineStepParams>;
  delayedDeliverySubtitles?: Maybe<Array<Maybe<GQLOrderDeliveryTimelineStepSubtitle>>>;
};

export enum GQLOrderDeliveryTimelineState {
  Unknown = 'unknown',
  Success = 'success',
  Warning = 'warning',
  Canceled = 'canceled'
}

export type GQLOrderDeliveryTimelineStep = {
  __typename?: 'OrderDeliveryTimelineStep';
  isActive: Scalars['Boolean'];
  isCompleted: Scalars['Boolean'];
  state: GQLOrderDeliveryTimelineState;
  step: GQLOrderDeliveryTimelineStepKey;
  params?: Maybe<GQLOrderDeliveryTimelineStepParams>;
  title?: Maybe<GQLOrderDeliveryTimelineStepTitle>;
  subtitles?: Maybe<Array<Maybe<GQLOrderDeliveryTimelineStepSubtitle>>>;
  delayedDeliverySubtitles?: Maybe<Array<Maybe<GQLOrderDeliveryTimelineStepSubtitle>>>;
};

export enum GQLOrderDeliveryTimelineStepKey {
  Step_1 = 'step_1',
  Step_2 = 'step_2',
  Step_3 = 'step_3',
  Step_4 = 'step_4',
  Step_5 = 'step_5'
}

export type GQLOrderDeliveryTimelineStepParams = {
  __typename?: 'OrderDeliveryTimelineStepParams';
  isDelayed?: Maybe<Scalars['Boolean']>;
  eventCode?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['DateTime']>;
  customerDeliveryDate?: Maybe<Scalars['DateTime']>;
  lastCustomerDeliveryDate?: Maybe<Scalars['DateTime']>;
  pickupDate?: Maybe<Scalars['DateTime']>;
};

export type GQLOrderDeliveryTimelineStepSubtitle = {
  __typename?: 'OrderDeliveryTimelineStepSubtitle';
  translated?: Maybe<Scalars['String']>;
  type?: Maybe<GQLOrderDeliveryTimelineStepSubtitleType>;
};

export enum GQLOrderDeliveryTimelineStepSubtitleType {
  Description = 'description',
  Important = 'important',
  EventDate = 'event_date',
  Warning = 'warning'
}

export type GQLOrderDeliveryTimelineStepTitle = {
  __typename?: 'OrderDeliveryTimelineStepTitle';
  translated?: Maybe<Scalars['String']>;
};

export type GQLOrderInvoice = {
  __typename?: 'OrderInvoice';
  content: Scalars['String'];
};

export type GQLOrderItem = {
  __typename?: 'OrderItem';
  itemId: Scalars['ID'];
  articleId: Scalars['String'];
  type: GQLOrderItemType;
  delivery: GQLOrderDelivery;
  price: GQLOrderItemPrice;
  isDigitalContent?: Maybe<Scalars['Boolean']>;
  isCancelable?: Maybe<Scalars['Boolean']>;
  amount: Scalars['Int'];
  title: Scalars['String'];
  mediaId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  status?: Maybe<GQLOrderStatus>;
  product?: Maybe<GQLProduct>;
  services?: Maybe<Array<GQLOrderItemService>>;
  partner?: Maybe<GQLOrderPartner>;
};

export type GQLOrderItemPrice = {
  __typename?: 'OrderItemPrice';
  price: Scalars['Float'];
  base: Scalars['Float'];
  currency: Scalars['String'];
};

export type GQLOrderItemService = {
  __typename?: 'OrderItemService';
  type: Scalars['String'];
  price: Scalars['Float'];
  priceBase: Scalars['Float'];
  vat?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export enum GQLOrderItemType {
  Variant = 'variant',
  Gift = 'gift',
  Marketplace = 'marketplace',
  VariantNatrabat = 'variant_natrabat',
  Gc = 'gc',
  Mes = 'mes',
  Esd = 'esd'
}

export type GQLOrderOutlet = {
  __typename?: 'OrderOutlet';
  id?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  street?: Maybe<Scalars['String']>;
  buildingNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  openingHours?: Maybe<Array<GQLOrderOutletOpeningHours>>;
  mediaIds?: Maybe<Array<Scalars['ID']>>;
  icon?: Maybe<Scalars['String']>;
  paymentMethods?: Maybe<Array<Scalars['String']>>;
  significantPoint?: Maybe<Scalars['String']>;
};

export type GQLOrderOutletOpeningHours = {
  __typename?: 'OrderOutletOpeningHours';
  day: Scalars['String'];
  hours: Array<GQLOrderOutletOpeningHoursTime>;
};

export type GQLOrderOutletOpeningHoursTime = {
  __typename?: 'OrderOutletOpeningHoursTime';
  openTime: Scalars['String'];
  closeTime: Scalars['String'];
};

export type GQLOrderPartner = {
  __typename?: 'OrderPartner';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GQLOrderPayment = {
  __typename?: 'OrderPayment';
  paymentId?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  fee: Scalars['Float'];
  delivery?: Maybe<GQLOrderDelivery>;
  status?: Maybe<Scalars['String']>;
  billingMethod: GQLOrderPaymentBillingMethod;
  paymentMethodId?: Maybe<Scalars['String']>;
};

export type GQLOrderPaymentBillingMethod = {
  __typename?: 'OrderPaymentBillingMethod';
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  imageMediaId?: Maybe<Scalars['String']>;
};

export type GQLOrderPaymentInformation = {
  __typename?: 'OrderPaymentInformation';
  orderId: Scalars['Int'];
  total: Scalars['Float'];
  paymentNumber?: Maybe<Scalars['String']>;
  iban: Scalars['String'];
  currencyId: Scalars['String'];
  bankAccount: Scalars['String'];
  decimalPoints: Scalars['Int'];
  constantSymbol?: Maybe<Scalars['String']>;
  billingMethod?: Maybe<Scalars['String']>;
  paymentTitle?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
};

export type GQLOrderPaymentInput = {
  paymentId?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  price: Scalars['Float'];
  fee: Scalars['Float'];
  deliveryId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  billingMethodId?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
};

export enum GQLOrderReadyForHandover {
  NotReady = 'not_ready',
  ReadyPupClosed = 'ready_pup_closed',
  ReadyPupOpened = 'ready_pup_opened'
}

export type GQLOrderResolvedPayment = {
  __typename?: 'OrderResolvedPayment';
  /** Can be anything, returned as JSON string */
  formData: Scalars['String'];
  status: GQLPaymentResponseStatus;
  confirmationUrl: Scalars['String'];
  gatewayUrl?: Maybe<Scalars['String']>;
  actions?: Maybe<GQLPaymentActions>;
};

export type GQLOrderStatus = {
  __typename?: 'OrderStatus';
  key: GQLOrderStatusKey;
  label: Scalars['String'];
};

export enum GQLOrderStatusKey {
  New = 'new',
  Open = 'open',
  Closed = 'closed',
  Cancelled = 'cancelled',
  Unprocessed = 'unprocessed',
  PartDelivery = 'part_delivery',
  Refused = 'refused',
  Archived = 'archived'
}

export type GQLOrderTotal = {
  __typename?: 'OrderTotal';
  currency: Scalars['String'];
  price: Scalars['Float'];
  base: Scalars['Float'];
  vat: Scalars['Float'];
  discountTotal: Scalars['Float'];
  totalToPay: Scalars['Float'];
};

export type GQLOrderTracking = {
  __typename?: 'OrderTracking';
  date: Scalars['DateTime'];
  code: Scalars['String'];
  text: Scalars['String'];
};

export enum GQLOrderType {
  Asc = 'asc',
  Desc = 'desc'
}

export type GQLPageBanner = GQLPageBannerBanners | GQLPageBannerCarousel | GQLPageBannerUspBanner | GQLPageBannerSlimBanner | GQLPageBannerDailyDealBanner | GQLPageBannerBannerFarm | GQLPageBannerHpBanner | GQLPageBannerTopIconsBanner | GQLPageBannerCmsCarouselWithImage | GQLPageBannerInspoBanner;

export type GQLPageBannerAttributes = {
  __typename?: 'PageBannerAttributes';
  header?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  headerCentered?: Maybe<Scalars['Boolean']>;
};

export type GQLPageBannerBannerFarm = GQLPageBannerBase & {
  __typename?: 'PageBannerBannerFarm';
  position: Scalars['Int'];
  bannerId: Scalars['ID'];
  bannerAttributes: GQLPageBannerBannerFarmAttributes;
  bannerSlides?: Maybe<Array<GQLPageBannerBannerFarmSlides>>;
};

export type GQLPageBannerBannerFarmAttributes = {
  __typename?: 'PageBannerBannerFarmAttributes';
  header?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  headerCentered?: Maybe<Scalars['Boolean']>;
  backgroundColor?: Maybe<Scalars['String']>;
};

export type GQLPageBannerBannerFarmSlides = GQLPageBannerSlideImage;

export type GQLPageBannerBanners = GQLPageBannerBase & {
  __typename?: 'PageBannerBanners';
  position: Scalars['Int'];
  bannerId: Scalars['ID'];
  bannerSlides?: Maybe<Array<GQLPageBannerSlideImage>>;
  bannerAttributes: GQLPageBannerAttributes;
};

export type GQLPageBannerBase = {
  position: Scalars['Int'];
  bannerId: Scalars['ID'];
};

export type GQLPageBannerButton = {
  __typename?: 'PageBannerButton';
  text: Scalars['String'];
  url: Scalars['String'];
};

export type GQLPageBannerCarousel = GQLPageBannerBase & {
  __typename?: 'PageBannerCarousel';
  position: Scalars['Int'];
  bannerId: Scalars['ID'];
  bannerAttributes: GQLPageBannerCarouselAttributes;
  bannerSlides?: Maybe<Array<GQLPageBannerSlideImage>>;
};

export type GQLPageBannerCarouselAttributes = {
  __typename?: 'PageBannerCarouselAttributes';
  header?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  headerCentered?: Maybe<Scalars['Boolean']>;
  autoplay: Scalars['Boolean'];
  imgBorderRadius?: Maybe<Scalars['String']>;
};

export type GQLPageBannerCmsCarouselWithImage = GQLPageBannerBase & {
  __typename?: 'PageBannerCmsCarouselWithImage';
  position: Scalars['Int'];
  bannerId: Scalars['ID'];
  bannerAttributes: GQLPageBannerCmsCarouselWithImageAttributes;
  bannerSlides?: Maybe<Array<GQLPageBannerSlideImage>>;
  isAllegroStyle: Scalars['Boolean'];
  items: Array<GQLProductCollectionItems>;
};


export type GQLPageBannerCmsCarouselWithImageItemsArgs = {
  isMobile: Scalars['Boolean'];
};

export type GQLPageBannerCmsCarouselWithImageAttributes = {
  __typename?: 'PageBannerCmsCarouselWithImageAttributes';
  version: Scalars['String'];
  gridConfig: GQLPageBannerCmsCarouselWithImageAttributesGridConfig;
  bgConfDesktop: GQLPageBannerCmsCarouselWithImageAttributesBgConf;
  bgConfMobile: GQLPageBannerCmsCarouselWithImageAttributesBgConf;
  header?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  headerCentered?: Maybe<Scalars['Boolean']>;
};

export type GQLPageBannerCmsCarouselWithImageAttributesBgConf = {
  __typename?: 'PageBannerCmsCarouselWithImageAttributesBgConf';
  titleColor: Scalars['String'];
  bgSize: Scalars['Int'];
  bgRepeat: Scalars['String'];
  bgPosition: Scalars['String'];
  bgColor: Scalars['String'];
  mediaId?: Maybe<Scalars['String']>;
};

export type GQLPageBannerCmsCarouselWithImageAttributesGridConfig = {
  __typename?: 'PageBannerCmsCarouselWithImageAttributesGridConfig';
  value: Scalars['String'];
  imageWidth?: Maybe<Scalars['Int']>;
  carouselWidth?: Maybe<Scalars['Int']>;
};

export type GQLPageBannerDailyDealBanner = GQLPageBannerBase & {
  __typename?: 'PageBannerDailyDealBanner';
  position: Scalars['Int'];
  bannerId: Scalars['ID'];
  bannerAttributes: GQLPageBannerDailyDealBannerAttributes;
  gaTag?: Maybe<Scalars['String']>;
};

export type GQLPageBannerDailyDealBannerAttributes = {
  __typename?: 'PageBannerDailyDealBannerAttributes';
  header?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  headerCentered?: Maybe<Scalars['Boolean']>;
  backgroundColor?: Maybe<Scalars['String']>;
  validTo?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productTitle?: Maybe<Scalars['String']>;
  productHeadline?: Maybe<Scalars['String']>;
};

export type GQLPageBannerHpBanner = GQLPageBannerBase & {
  __typename?: 'PageBannerHpBanner';
  position: Scalars['Int'];
  bannerId: Scalars['ID'];
  gaTag?: Maybe<Scalars['String']>;
  bannerSlides?: Maybe<Array<GQLPageBannerSlideImage>>;
  bannerAttributes: GQLPageBannerHpBannerAttributes;
  topIcons?: Maybe<GQLPageBannerTopIconsBanner>;
};

export type GQLPageBannerHpBannerAttributes = {
  __typename?: 'PageBannerHpBannerAttributes';
  header?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  headerCentered?: Maybe<Scalars['Boolean']>;
};

export type GQLPageBannerInspoBanner = GQLPageBannerBase & {
  __typename?: 'PageBannerInspoBanner';
  position: Scalars['Int'];
  bannerId: Scalars['ID'];
  bannerAttributes: GQLPageBannerInspoBannerAttributes;
  bannerSlides?: Maybe<Array<GQLPageBannerSlideImage>>;
};

export type GQLPageBannerInspoBannerAttributes = {
  __typename?: 'PageBannerInspoBannerAttributes';
  header?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  headerCentered?: Maybe<Scalars['Boolean']>;
};

export type GQLPageBannerPoint = {
  __typename?: 'PageBannerPoint';
  title?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
};

export type GQLPageBanners = {
  __typename?: 'PageBanners';
  pageId: Scalars['String'];
  headerBanner?: Maybe<GQLHeaderBanner>;
  backgroundBanner?: Maybe<GQLBackgroundBanner>;
  infoBanner?: Maybe<GQLInfoBanner>;
  upperRightCornerBanner?: Maybe<GQLUpperRightCornerBanner>;
};

export type GQLPageBannerSlide = {
  slideId: Scalars['ID'];
  position: Scalars['Int'];
  gaTag?: Maybe<Scalars['String']>;
  urlNewWindow: Scalars['Boolean'];
  v2: Scalars['Boolean'];
};

export type GQLPageBannerSlideImage = GQLPageBannerSlide & {
  __typename?: 'PageBannerSlideImage';
  slideId: Scalars['ID'];
  position: Scalars['Int'];
  gaTag?: Maybe<Scalars['String']>;
  urlNewWindow: Scalars['Boolean'];
  v2: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  mediaId: Scalars['String'];
  mediaIdMobile?: Maybe<Scalars['String']>;
  mediaIdMobileApp?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
};

export type GQLPageBannerSlideTopIcon = GQLPageBannerSlide & {
  __typename?: 'PageBannerSlideTopIcon';
  slideId: Scalars['ID'];
  position: Scalars['Int'];
  gaTag?: Maybe<Scalars['String']>;
  urlNewWindow: Scalars['Boolean'];
  v2: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
  firstRow?: Maybe<Scalars['String']>;
  secondRow?: Maybe<Scalars['String']>;
  mediaId: Scalars['String'];
  mediaIdMobile?: Maybe<Scalars['String']>;
  mediaIdMobileApp?: Maybe<Scalars['String']>;
};

export type GQLPageBannerSlimBanner = GQLPageBannerBase & {
  __typename?: 'PageBannerSlimBanner';
  position: Scalars['Int'];
  bannerId: Scalars['ID'];
  bannerAttributes: GQLPageBannerSlimBannerAttributes;
  bannerSlides?: Maybe<Array<GQLPageBannerSlideImage>>;
};

export type GQLPageBannerSlimBannerAttributes = {
  __typename?: 'PageBannerSlimBannerAttributes';
  header?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  headerCentered?: Maybe<Scalars['Boolean']>;
  borderRadius?: Maybe<Scalars['String']>;
  backgroundSize?: Maybe<Scalars['String']>;
  backgroundPosition?: Maybe<Scalars['String']>;
};

export type GQLPageBannerTopIconsBanner = GQLPageBannerBase & {
  __typename?: 'PageBannerTopIconsBanner';
  position: Scalars['Int'];
  bannerId: Scalars['ID'];
  bannerAttributes: GQLPageBannerTopIconsBannerAttributes;
  bannerSlides?: Maybe<Array<GQLPageBannerSlideTopIcon>>;
};

export type GQLPageBannerTopIconsBannerAttributes = {
  __typename?: 'PageBannerTopIconsBannerAttributes';
  contentCentered: Scalars['Boolean'];
  header?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  headerCentered?: Maybe<Scalars['Boolean']>;
  enableSliding: Scalars['Boolean'];
};

export type GQLPageBannerUspBanner = GQLPageBannerBase & {
  __typename?: 'PageBannerUspBanner';
  position: Scalars['Int'];
  bannerId: Scalars['ID'];
  bannerAttributes: GQLPageBannerUspBannerAttributes;
  gaTag?: Maybe<Scalars['String']>;
};

export type GQLPageBannerUspBannerAttributes = {
  __typename?: 'PageBannerUspBannerAttributes';
  header?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  headerCentered?: Maybe<Scalars['Boolean']>;
  mediaId?: Maybe<Scalars['String']>;
  iconsBackgroundColor?: Maybe<Scalars['String']>;
  bannerBackgroundColor?: Maybe<Scalars['String']>;
  bannerBackgroundRepeat?: Maybe<Scalars['Boolean']>;
  pointTextColor?: Maybe<Scalars['String']>;
  button?: Maybe<GQLPageBannerButton>;
  points?: Maybe<Array<GQLPageBannerPoint>>;
};

export type GQLPaginationInput = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type GQLParametricSiS = GQLIBaseSiSResponse & {
  __typename?: 'ParametricSiS';
  title?: Maybe<Scalars['String']>;
  breadcrumbs: Array<GQLCategory>;
  bestSellers: Array<GQLProduct>;
  productCollection?: Maybe<GQLProductCollection>;
  category?: Maybe<GQLContentCategory>;
};


export type GQLParametricSiSBestSellersArgs = {
  query?: Maybe<GQLBestSellersQueryInput>;
};


export type GQLParametricSiSProductCollectionArgs = {
  query?: Maybe<GQLProductCollectionQueryInput>;
};

export type GQLPartnerSiS = GQLIBaseSiSResponse & {
  __typename?: 'PartnerSiS';
  title?: Maybe<Scalars['String']>;
  breadcrumbs: Array<GQLCategory>;
  bestSellers: Array<GQLProduct>;
  productCollection?: Maybe<GQLProductCollection>;
  category?: Maybe<GQLContentCategory>;
};


export type GQLPartnerSiSBestSellersArgs = {
  query?: Maybe<GQLBestSellersQueryInput>;
};


export type GQLPartnerSiSProductCollectionArgs = {
  query?: Maybe<GQLProductCollectionQueryInput>;
};

export type GQLPaylightFinancialOffer = {
  __typename?: 'PaylightFinancialOffer';
  paymentMethodId: Scalars['String'];
  billingMethodId: Scalars['String'];
  installments: Scalars['Boolean'];
  promoted: Scalars['Boolean'];
};

export type GQLPaylightFinancialOfferResult = GQLBaseFinancialOfferResult & {
  __typename?: 'PaylightFinancialOfferResult';
  provider: GQLFinancialOfferProviders;
  offers: Array<GQLPaylightFinancialOffer>;
};

export type GQLPaymentActions = {
  __typename?: 'PaymentActions';
  fingerprint?: Maybe<GQLPaymentActionsFingerprint>;
  authenticate?: Maybe<GQLPaymentActionsAuthenticate>;
};

export type GQLPaymentActionsAuthenticate = {
  __typename?: 'PaymentActionsAuthenticate';
  browserChallenge?: Maybe<GQLPaymentActionsEndpoint>;
  sdkChallenge?: Maybe<GQLPaymentActionsAuthenticateSdkChallenge>;
};

export type GQLPaymentActionsAuthenticateSdkChallenge = {
  __typename?: 'PaymentActionsAuthenticateSdkChallenge';
  threeDSServerTransID: Scalars['String'];
  acsReferenceNumber: Scalars['String'];
  acsTransID: Scalars['String'];
  acsSignedContent: Scalars['String'];
};

export type GQLPaymentActionsEndpoint = {
  __typename?: 'PaymentActionsEndpoint';
  url: Scalars['String'];
  method?: Maybe<GQLPaymentActionsEndpointMethod>;
  vars?: Maybe<Scalars['Object']>;
};

export enum GQLPaymentActionsEndpointMethod {
  Get = 'GET',
  Post = 'POST'
}

export type GQLPaymentActionsFingerprint = {
  __typename?: 'PaymentActionsFingerprint';
  browserInit?: Maybe<GQLPaymentActionsEndpoint>;
  sdkInit?: Maybe<GQLPaymentActionsFingerprintSdkInit>;
};

export type GQLPaymentActionsFingerprintSdkInit = {
  __typename?: 'PaymentActionsFingerprintSdkInit';
  directoryServerID: Scalars['String'];
  schemeId: Scalars['String'];
  messageVersion: Scalars['String'];
};

export type GQLPaymentCard = {
  __typename?: 'PaymentCard';
  id: Scalars['ID'];
  name: Scalars['String'];
  token: Scalars['String'];
  longMaskedCard: Scalars['String'];
  shortMaskedCard: Scalars['String'];
  provider: Scalars['String'];
  isActive: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  cardExpiration?: Maybe<Scalars['DateTime']>;
  lastUsed?: Maybe<Scalars['DateTime']>;
  created?: Maybe<Scalars['DateTime']>;
  changed?: Maybe<Scalars['DateTime']>;
};

export type GQLPaymentCardCollection = {
  __typename?: 'PaymentCardCollection';
  items: Array<GQLPaymentCard>;
  hits: Scalars['Int'];
};

export type GQLPaymentCardInfo = {
  __typename?: 'PaymentCardInfo';
  cardToken: Scalars['String'];
  expiration?: Maybe<Scalars['DateTime']>;
  shortMaskedCard?: Maybe<Scalars['String']>;
  longMaskedCard?: Maybe<Scalars['String']>;
};

export type GQLPaymentInfoResult = {
  __typename?: 'PaymentInfoResult';
  paymentId: Scalars['String'];
  externalId: Scalars['String'];
  orderId: Scalars['String'];
  token?: Maybe<Scalars['String']>;
  shopId: Scalars['String'];
  paymentMethodId: Scalars['String'];
  customerId: Scalars['String'];
  price: Scalars['Float'];
  currency: Scalars['String'];
  status: GQLPaymentInfoStatus;
  gatewayUrl?: Maybe<Scalars['String']>;
  additionalData?: Maybe<Scalars['Object']>;
  clientInitiated?: Maybe<Scalars['Boolean']>;
  actions?: Maybe<GQLPaymentActions>;
  cardInfo?: Maybe<GQLPaymentCardInfo>;
  rememberPayment?: Maybe<Scalars['Boolean']>;
  cardToken?: Maybe<Scalars['String']>;
  formData?: Maybe<Scalars['Object']>;
  created?: Maybe<Scalars['DateTime']>;
  ipAddress?: Maybe<Scalars['String']>;
};

export type GQLPaymentInfoStatus = {
  __typename?: 'PaymentInfoStatus';
  desc?: Maybe<Scalars['String']>;
  unified: GQLPaymentInfoUnifiedPaymentStatus;
  external: Scalars['String'];
};

export enum GQLPaymentInfoUnifiedPaymentStatus {
  New = 'NEW',
  Pending = 'PENDING',
  Completed = 'COMPLETED',
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Unknown = 'UNKNOWN'
}

export enum GQLPaymentResponseStatus {
  Ok = 'ok',
  Nok = 'nok',
  Pending = 'pending',
  Redirect = 'redirect'
}

export type GQLPfcFinancialOffer = {
  __typename?: 'PfcFinancialOffer';
  financingType: Scalars['String'];
  serviceVariants: Array<GQLPfcFinancialVariant>;
};

export type GQLPfcFinancialOfferResult = GQLBaseFinancialOfferResult & {
  __typename?: 'PfcFinancialOfferResult';
  provider: GQLFinancialOfferProviders;
  offers: Array<GQLPfcFinancialOffer>;
};

export type GQLPfcFinancialVariant = {
  __typename?: 'PfcFinancialVariant';
  id: Scalars['Int'];
  rank: Scalars['Int'];
  providerCode: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
};





export type GQLPricePerUnit = {
  __typename?: 'PricePerUnit';
  value: Scalars['Float'];
  measure: Scalars['String'];
};

export type GQLProcessPaymentBrowserFingerprint = {
  javascriptEnabled: Scalars['Boolean'];
  timezoneOffset: Scalars['Int'];
  headers: GQLProcessPaymentBrowserFingerprintHeaders;
  navigator: GQLProcessPaymentBrowserFingerprintNavigator;
  screen: GQLProcessPaymentBrowserFingerprintScreen;
};

export type GQLProcessPaymentBrowserFingerprintHeaders = {
  accept: Scalars['String'];
};

export type GQLProcessPaymentBrowserFingerprintNavigator = {
  userAgent: Scalars['String'];
  language: Scalars['String'];
  javaEnabled: Scalars['Boolean'];
  appCodeName?: Maybe<Scalars['String']>;
  appName?: Maybe<Scalars['String']>;
  appVersion?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
};

export type GQLProcessPaymentBrowserFingerprintScreen = {
  height: Scalars['Int'];
  width: Scalars['Int'];
  colorDepth: Scalars['Int'];
  pixelDepth?: Maybe<Scalars['Int']>;
};

export type GQLProcessPaymentFingerprint = {
  browser?: Maybe<GQLProcessPaymentBrowserFingerprint>;
  sdk?: Maybe<Scalars['Object']>;
};

export type GQLProcessPaymentInput = {
  paymentId: Scalars['String'];
  fingerprint?: Maybe<GQLProcessPaymentFingerprint>;
};

export type GQLProduct = {
  __typename?: 'Product';
  id: Scalars['ID'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  brief?: Maybe<Scalars['String']>;
  mainVariant: GQLProductVariant;
  variantsCount: Scalars['Int'];
  variants: Array<GQLProductVariant>;
  mainMenuUrlKey: Scalars['String'];
  mainCategoryUrlKey: Scalars['String'];
  mainCategory?: Maybe<GQLCategory>;
  isAdultOnly: Scalars['Boolean'];
  urlKey: Scalars['String'];
  rank?: Maybe<GQLRank>;
  division?: Maybe<Scalars['String']>;
  productTypeId: Scalars['String'];
  energyLabel?: Maybe<GQLEnergyLabel>;
  breadcrumbs: Array<GQLCategory>;
  marketplace?: Maybe<GQLMarketplaceProductData>;
  campaign?: Maybe<GQLCampaign>;
  /**  It returns just simple variant params information. For getting product variants based on variant parameters use query getProductVariantParametersDetail  */
  variantParameters: Array<GQLProductVariantParameter>;
  secondPrice?: Maybe<GQLSecondPrice>;
  pictograms: Array<GQLProductPictogram>;
  identicalProductIds: Array<Scalars['ID']>;
  linkedProducts?: Maybe<GQLLinkedProducts>;
  lowestProductPrice?: Maybe<Scalars['Float']>;
  discussions: Array<GQLDiscussionComment>;
  fmcgCategory?: Maybe<Scalars['String']>;
  testDriveRequest?: Maybe<GQLTestDriveRequest>;
  menu: Array<GQLProductMenu>;
  reviewBox: GQLProductReviewBox;
  coupons: Array<GQLCoupon>;
};


export type GQLProductDescriptionArgs = {
  normalizeHtml?: Maybe<GQLNormalizeInput>;
};


export type GQLProductBreadcrumbsArgs = {
  categoryUrl: Scalars['String'];
};


export type GQLProductCampaignArgs = {
  campaignUrl?: Maybe<Scalars['String']>;
};


export type GQLProductDiscussionsArgs = {
  pagination?: Maybe<GQLPaginationInput>;
};

export type GQLProductAutocomplete = {
  __typename?: 'ProductAutocomplete';
  id: Scalars['ID'];
  title: Scalars['String'];
  fullUrl: Scalars['String'];
  mediaId?: Maybe<Scalars['Int']>;
  rank?: Maybe<Scalars['Float']>;
  isAdultOnly?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  availability?: Maybe<GQLProductAvailability>;
};

export type GQLProductAvailability = {
  __typename?: 'ProductAvailability';
  /**  Key of stock where is product/variant available - example: avail-stock-mall  */
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  countMall?: Maybe<Scalars['Int']>;
  countSupplier?: Maybe<Scalars['Int']>;
  countExternal?: Maybe<Scalars['Int']>;
  countOutlets?: Maybe<Scalars['Int']>;
  countShowrooms?: Maybe<Scalars['Int']>;
  sourceCountryId?: Maybe<Scalars['String']>;
  supplierDeliveryTermDays?: Maybe<Scalars['Int']>;
  supplierProcessingTermDays?: Maybe<Scalars['Int']>;
  isAvailable: Scalars['Boolean'];
  outlets: Array<GQLShowroom>;
  showrooms: Array<GQLShowroom>;
};

export type GQLProductBundle = GQLBaseProductBundle | GQLDigitalContentBundle;

export type GQLProductBundleVariant = {
  __typename?: 'ProductBundleVariant';
  id: Scalars['String'];
  title: Scalars['String'];
  actualPrice: Scalars['Float'];
  yearsNumber: Scalars['Int'];
};

export type GQLProductCategory = GQLCategory & {
  __typename?: 'ProductCategory';
  id: Scalars['ID'];
  footer?: Maybe<Array<GQLFooter>>;
  shoppingWizard?: Maybe<GQLShoppingWizardPreview>;
  title: Scalars['String'];
  titleFull?: Maybe<Scalars['String']>;
  titleStructured?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['Int']>;
  secondaryMediaId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  metaDescription?: Maybe<Scalars['String']>;
  metaKeywords?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  howto?: Maybe<Scalars['String']>;
  productOrder?: Maybe<Scalars['String']>;
  breadcrumbs: Array<GQLCategory>;
  children: Array<GQLCategory>;
  isRepresentative: Scalars['Boolean'];
  isMainTile: Scalars['Boolean'];
  menu: Array<GQLMixedChildren>;
  typeVersion: Scalars['Int'];
  isTrendy: Scalars['Boolean'];
  indexSeo?: Maybe<Scalars['Boolean']>;
  giftHelperUrl?: Maybe<Scalars['String']>;
  giftHelperTitle?: Maybe<Scalars['String']>;
  productCollection?: Maybe<GQLProductCollection>;
  bestSellers: Array<GQLProduct>;
  sapCategories: Array<GQLSapCategories>;
  noIndexParams: Array<Array<GQLNoIndexParam>>;
  advisorParameters: Array<Scalars['String']>;
  hasPossiblyVirtualCategories: Scalars['Boolean'];
  coupon?: Maybe<GQLCoupon>;
};


export type GQLProductCategoryDescriptionArgs = {
  normalizeHtml?: Maybe<GQLNormalizeInput>;
};


export type GQLProductCategoryChildrenArgs = {
  sort?: Maybe<GQLCategorySort>;
  visibility?: Maybe<GQLCategoryVisibility>;
};


export type GQLProductCategoryMenuArgs = {
  usedFilters?: Maybe<Array<GQLProductFilterValueInput>>;
};


export type GQLProductCategoryProductCollectionArgs = {
  query?: Maybe<GQLCategoryProductCollectionQueryInput>;
};


export type GQLProductCategoryBestSellersArgs = {
  query?: Maybe<GQLBestSellersQueryInput>;
};

export type GQLProductCollection = {
  __typename?: 'ProductCollection';
  items?: Maybe<Array<GQLProductCollectionItems>>;
  itemsTotalCount: Scalars['Int'];
  categories?: Maybe<Array<GQLCategory>>;
  breadcrumbs?: Maybe<Array<GQLCategory>>;
  bonusSetTotalCount: Scalars['Int'];
};

export type GQLProductCollectionItems = GQLProduct | GQLBonusSet | GQLSectionBannerSlideImage | GQLSectionBannerSlideProduct;

export type GQLProductCollectionPaginationInput = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  prefetchCount?: Maybe<Scalars['Int']>;
};

export type GQLProductCollectionQueryInput = {
  /** Default pagination is set - limit 40 offset 0 */
  pagination?: Maybe<GQLProductCollectionPaginationInput>;
  categoryUrlKey?: Maybe<Scalars['String']>;
  productSorting?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<GQLProductFilterValueInput>>;
  allFilters?: Maybe<Scalars['Boolean']>;
  sortVersion?: Maybe<Scalars['String']>;
};

export type GQLProductFilter = {
  __typename?: 'ProductFilter';
  id: Scalars['ID'];
  group: Scalars['String'];
  type: Scalars['String'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  measure?: Maybe<GQLProductFilterMeasure>;
  values: GQLProductFilterValues;
  usage?: Maybe<Scalars['String']>;
};

export type GQLProductFilterCollection = {
  __typename?: 'ProductFilterCollection';
  filters: Array<GQLProductFilter>;
  hasLazyLoadFilters: Scalars['Boolean'];
  hits: Scalars['Int'];
};

export type GQLProductFilteringDefinitions = {
  __typename?: 'ProductFilteringDefinitions';
  title: Scalars['String'];
  gaLabel: Scalars['String'];
  valueUrlKey: Scalars['String'];
  valueId: Scalars['String'];
  filter?: Maybe<Scalars['String']>;
};

export type GQLProductFilterItem = {
  __typename?: 'ProductFilterItem';
  title: Scalars['String'];
  count: Scalars['Int'];
  isActive: Scalars['Boolean'];
  valueId: Scalars['String'];
  valueUrlKey: Scalars['String'];
  css?: Maybe<Scalars['String']>;
};

export type GQLProductFilterItemsValues = {
  __typename?: 'ProductFilterItemsValues';
  items: Array<GQLProductFilterItem>;
};

export type GQLProductFilterMeasure = {
  __typename?: 'ProductFilterMeasure';
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type GQLProductFilterRangeValues = {
  __typename?: 'ProductFilterRangeValues';
  abs: Array<Scalars['Float']>;
  user: Array<Scalars['Float']>;
  percentiles?: Maybe<Array<Scalars['Float']>>;
};

export type GQLProductFilterValueInput = {
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Scalars['String']>>;
  range?: Maybe<GQLRangeInput>;
};

export type GQLProductFilterValues = GQLProductFilterRangeValues | GQLProductFilterItemsValues;

export type GQLProductMenu = {
  __typename?: 'ProductMenu';
  id: Scalars['ID'];
  urlKey: Scalars['String'];
};

export type GQLProductParameter = {
  __typename?: 'ProductParameter';
  key: Scalars['String'];
  order: Scalars['Int'];
  title: Scalars['String'];
  value: Scalars['String'];
  paramValueId: Scalars['String'];
  visible: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  measure?: Maybe<GQLVariantParameterMeasure>;
  groupId: Scalars['String'];
};

export type GQLProductPictogram = {
  __typename?: 'ProductPictogram';
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  urlNewWindow: Scalars['Boolean'];
  hoverText?: Maybe<Scalars['String']>;
  mediaId: Scalars['String'];
  gaTag?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type GQLProductReview = {
  __typename?: 'ProductReview';
  id: Scalars['ID'];
  user?: Maybe<Scalars['String']>;
  rank: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  showAuthor: Scalars['Boolean'];
  medias: Array<GQLReviewMedia>;
  createdAt: Scalars['DateTime'];
  pros: Array<Scalars['String']>;
  cons: Array<Scalars['String']>;
  source: Scalars['String'];
  usefulness: GQLReviewUsefulness;
  productId: Scalars['ID'];
  variantId: Scalars['ID'];
};

export type GQLProductReviewBox = {
  __typename?: 'ProductReviewBox';
  reviews: Array<GQLProductReview>;
  stats?: Maybe<GQLReviewStats>;
};

export type GQLProductReviewCollection = {
  __typename?: 'ProductReviewCollection';
  items: Array<GQLProductReview>;
  hits: Scalars['Int'];
};

export type GQLProductSortingDefinitions = {
  __typename?: 'ProductSortingDefinitions';
  title: Scalars['String'];
  sortBy: Scalars['String'];
  gaLabel: Scalars['String'];
};

export type GQLProductVariant = {
  __typename?: 'ProductVariant';
  id: Scalars['ID'];
  allegroProductVariant?: Maybe<GQLAllegroProductVariant>;
  title: Scalars['String'];
  variantUrl: Scalars['String'];
  description: Scalars['String'];
  brief?: Maybe<Scalars['String']>;
  brand?: Maybe<GQLBrand>;
  brandManufacturer?: Maybe<GQLBrandManufacturer>;
  currency: Scalars['String'];
  currencyAbbr: Scalars['String'];
  price: Scalars['Float'];
  pricePerUnit?: Maybe<GQLPricePerUnit>;
  /** @deprecated Use pricePerUnit instead. This property no longer works */
  unitPrice?: Maybe<Scalars['Float']>;
  priceRrp?: Maybe<Scalars['Float']>;
  vatRate?: Maybe<Scalars['Float']>;
  rrpSavePercent?: Maybe<Scalars['Int']>;
  discountPrice?: Maybe<Scalars['Float']>;
  discountPromotionPrice?: Maybe<Scalars['Float']>;
  discountPromotionSalePrice: Scalars['Float'];
  discountPromotionAmount?: Maybe<Scalars['Int']>;
  discountMOCPrice?: Maybe<Scalars['Float']>;
  defaultActualPrice?: Maybe<Scalars['Float']>;
  promotionPrice?: Maybe<Scalars['Float']>;
  promotionStart?: Maybe<Scalars['DateTime']>;
  promotionEnd?: Maybe<Scalars['DateTime']>;
  mediaIds?: Maybe<Array<Scalars['Int']>>;
  specialMediaIds?: Maybe<Array<Scalars['Int']>>;
  specialMedia: Array<GQLSpecialMedia>;
  mediaId?: Maybe<Scalars['Int']>;
  availability: GQLProductAvailability;
  isAvailable: Scalars['Boolean'];
  labels: Array<Scalars['String']>;
  labelsData: Array<GQLLabelsData>;
  variantStickers?: Maybe<Array<GQLProductVariantStickers>>;
  gift: Scalars['Boolean'];
  /** @deprecated Proben service is dead */
  benefits: Array<GQLProductVariantBenefits>;
  hasSale: Scalars['Boolean'];
  inPromotion?: Maybe<Scalars['Boolean']>;
  mainMenuPath: Array<Scalars['String']>;
  extendedWarranty?: Maybe<Scalars['Object']>;
  return60DaysService?: Maybe<Scalars['Object']>;
  insurance?: Maybe<Scalars['Object']>;
  giftDetails?: Maybe<GQLGiftDetails>;
  giftVariantsCount?: Maybe<Scalars['Object']>;
  priceType?: Maybe<Scalars['String']>;
  energyLabelMedia?: Maybe<Array<GQLEnergyLabelMedia>>;
  parameters: Array<GQLProductParameter>;
  hasWeeeFee: Scalars['Boolean'];
  digitalContentBundlesInfo: Array<Maybe<GQLDigitalContentBundleInfo>>;
  bundles: Array<Maybe<GQLProductBundle>>;
  materialType?: Maybe<Scalars['String']>;
  packageGroupId: Scalars['Int'];
  packageGroup: Scalars['String'];
  marketplace: GQLMarketplaceVariantData;
  availableOutlets: Array<Scalars['String']>;
  weight: GQLProductWeight;
  estimatedDeliveries?: Maybe<GQLEstimatedDelivery>;
  bonusSetIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  bazaarProductsIds: Array<Scalars['ID']>;
  recommendedVariants: Array<Scalars['ID']>;
  freeDelivery?: Maybe<Scalars['Boolean']>;
  pricingGroup?: Maybe<Scalars['String']>;
  pricingGroups?: Maybe<Array<GQLProductVariantPricingGroup>>;
  isDiscountAction?: Maybe<Scalars['Boolean']>;
  discountAction?: Maybe<GQLProductVariantDiscountAction>;
  groupAttributeValues?: Maybe<Scalars['Object']>;
  galleryVideos: Array<Scalars['String']>;
  mallService?: Maybe<GQLMallService>;
  size: GQLProductVariantSize;
  marketplaceType: Scalars['String'];
  originalSalePrice: Scalars['Float'];
  productAmount?: Maybe<Scalars['Int']>;
  ean: Scalars['String'];
  salesCount: Scalars['Int'];
  isSimpleReturnEligible: Scalars['Boolean'];
  coupon?: Maybe<GQLCoupon>;
};


export type GQLProductVariantDescriptionArgs = {
  normalizeHtml?: Maybe<GQLNormalizeInput>;
};


export type GQLProductVariantVariantStickersArgs = {
  useCase?: Maybe<GQLVariantStickerUseCase>;
};


export type GQLProductVariantEstimatedDeliveriesArgs = {
  type?: Maybe<GQLEstimatedDeliveriesType>;
};


export type GQLProductVariantMallServiceArgs = {
  categoryId?: Maybe<Scalars['String']>;
  categoryUrl?: Maybe<Scalars['String']>;
};

export type GQLProductVariantBenefits = {
  __typename?: 'ProductVariantBenefits';
  id: Scalars['ID'];
  name: Scalars['String'];
  firstText?: Maybe<Scalars['String']>;
  secondText?: Maybe<Scalars['String']>;
  type: Scalars['Int'];
  discountPercent?: Maybe<Scalars['Int']>;
  discountAmount?: Maybe<Scalars['Int']>;
};

export type GQLProductVariantDiscountAction = {
  __typename?: 'ProductVariantDiscountAction';
  sendAfter: Scalars['Int'];
  actionId: Scalars['String'];
  actionName: Scalars['String'];
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
  discount: Scalars['Int'];
};

export type GQLProductVariantParameter = {
  __typename?: 'ProductVariantParameter';
  id: Scalars['ID'];
  name: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  items: Array<GQLProductVariantParameterItem>;
};

export type GQLProductVariantParameterItem = {
  __typename?: 'ProductVariantParameterItem';
  id: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  variantUrls: Array<GQLProductVariantParameterItemUrl>;
  variantIds: Array<Scalars['ID']>;
  imageId?: Maybe<Scalars['Int']>;
  colorId?: Maybe<Scalars['String']>;
  urlKey?: Maybe<Scalars['String']>;
};

export type GQLProductVariantParameterItemUrl = {
  __typename?: 'ProductVariantParameterItemUrl';
  id: Scalars['ID'];
  paramValue: Scalars['String'];
  url: Scalars['String'];
};

export type GQLProductVariantParametersDetail = GQLIProductVariantParametersDetail & {
  __typename?: 'ProductVariantParametersDetail';
  entityId: Scalars['String'];
  parameterId: Scalars['String'];
  valueId: Scalars['String'];
  value: Scalars['String'];
  url: Scalars['String'];
  price: Scalars['Float'];
  available: Scalars['Boolean'];
  mediaId: Scalars['Int'];
  measure?: Maybe<Scalars['String']>;
};

export type GQLProductVariantParametersDetailFull = GQLIProductVariantParametersDetail & {
  __typename?: 'ProductVariantParametersDetailFull';
  entityId: Scalars['String'];
  parameterId: Scalars['String'];
  valueId: Scalars['String'];
  value: Scalars['String'];
  url: Scalars['String'];
  price: Scalars['Float'];
  available: Scalars['Boolean'];
  mediaId: Scalars['Int'];
  measure?: Maybe<Scalars['String']>;
  variants?: Maybe<Array<GQLProductVariantParametersDetail>>;
};

export type GQLProductVariantPricingGroup = {
  __typename?: 'ProductVariantPricingGroup';
  id: Scalars['String'];
  price: Scalars['Float'];
};

export type GQLProductVariantSize = {
  __typename?: 'ProductVariantSize';
  width: Scalars['Float'];
  height: Scalars['Float'];
  depth: Scalars['Float'];
};

export type GQLProductVariantStickers = {
  __typename?: 'ProductVariantStickers';
  name: Scalars['String'];
  text: Scalars['String'];
  date?: Maybe<Scalars['DateTime']>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  isStock: Scalars['Boolean'];
  isFromConfig: Scalars['Boolean'];
  localeText?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
};

export type GQLProductWeight = {
  __typename?: 'ProductWeight';
  brutto?: Maybe<Scalars['Int']>;
  netto?: Maybe<Scalars['Int']>;
};

export type GQLQuery = {
  __typename?: 'Query';
  getContent?: Maybe<GQLContent>;
  getContentByTitle?: Maybe<GQLContent>;
  getGlossary: Array<GQLGlossary>;
  getGlossaryTerm?: Maybe<GQLGlossaryTerm>;
  getAllegroLink?: Maybe<GQLAllegroLink>;
  getAllegroCarousel: Array<GQLCarousel>;
  getShoppingWizard?: Maybe<GQLShoppingWizardData>;
  getShoppingWizardMenu: Array<GQLShoppingWizardMenu>;
  getShoppingWizardMenuId?: Maybe<Scalars['Int']>;
  getExceptionEnums?: Maybe<GQLExceptionEnums>;
  getSplashScreenAd?: Maybe<GQLAd>;
  getProductByUrlKey?: Maybe<GQLProduct>;
  getProductById?: Maybe<GQLProduct>;
  getProductsByIds: Array<GQLProduct>;
  getProductVariantsByIds: Array<GQLProduct>;
  getBestsellersCarousel: Array<GQLProduct>;
  getCarouselProducts: Array<GQLProduct>;
  getProductVariantParametersDetail?: Maybe<GQLGetProductVariantParametersDetail>;
  getCategory?: Maybe<GQLCategory>;
  getCategories: Array<Maybe<GQLCategory>>;
  getCanonicalUrl?: Maybe<Scalars['String']>;
  getFiltersCollection?: Maybe<GQLProductFilterCollection>;
  /** Returns bonus set detail. */
  getBonusSet?: Maybe<GQLBonusSet>;
  getBonusSetByUrl?: Maybe<GQLBonusSet>;
  getBonusSets: Array<GQLBonusSet>;
  getPageBanners?: Maybe<GQLPageBanners>;
  getPositionedPageBanners: Array<GQLPageBanner>;
  getCampaign?: Maybe<GQLCampaign>;
  getProductDiscussionCollection?: Maybe<GQLDiscussionCollection>;
  getProductReviews: GQLProductReviewCollection;
  getProductReviewBox?: Maybe<GQLProductReviewBox>;
  getMyProductReviews: GQLProductReviewCollection;
  getReviewsMsgsJwk: GQLReviewsMsgsJwk;
  getReviewsMsgsTokenValidation: GQLReviewsMsgsTokenValidation;
  getShopInShop?: Maybe<GQLShopInShop>;
  /**  return object with generic structure {[namespace: string]: {[keyForTranslation: string]: string }}  */
  getTranslations?: Maybe<Scalars['Object']>;
  /**  Authenticated query, x-user-id header is mandatory. Returns main user whishlist.  */
  getMainWishList?: Maybe<GQLWishList>;
  /**  Authenticated query, x-user-id header is mandatory. Returns whishlist by user whishlist id.  */
  getWishList?: Maybe<GQLWishList>;
  /**  Authenticated query, x-user-id header is mandatory. Returns all whishlists for user.  */
  getWishLists?: Maybe<Array<Maybe<GQLWishList>>>;
  getWishListByHash?: Maybe<GQLWishListByHash>;
  getAutocomplete?: Maybe<GQLAutocompleteResult>;
  getSearch?: Maybe<GQLSearchResult>;
  quRedirectExists: Scalars['Boolean'];
  getMe?: Maybe<GQLUser>;
  getMyPaymentCards?: Maybe<GQLPaymentCardCollection>;
  getMyPaymentCard?: Maybe<GQLPaymentCard>;
  getConfig: GQLConfig;
  /** Returns all Cnc Links */
  getCncLinks: Array<GQLCncLink>;
  getFinancialOffers?: Maybe<GQLFinancialOfferResult>;
  getInstallmentsTiles?: Maybe<GQLInstallmentsTilesResult>;
  getInstallmentsSlider?: Maybe<GQLInstallmentsSliderResult>;
  getInstallmentsCalculation?: Maybe<GQLInstallmentsCalculationResult>;
  getInstallmentsInsurances?: Maybe<GQLInstallmentsInsurancesResult>;
  /**  Authenticated query, x-user-id header is mandatory. Returns user orders.  */
  getOrders: GQLOrderCollection;
  getOrder: GQLOrder;
  getOrderFromToken: GQLOrder;
  getOrderInvoice: GQLOrderInvoice;
  getDigitalContentOrder?: Maybe<GQLDigitalContentLicenceProductsCollection>;
  getDigitalContentProductKey?: Maybe<GQLDigitalLicenceProductKey>;
  getCustomerClub?: Maybe<GQLCustomerClub>;
  getClubSubscriptions: GQLClubSubscriptionCollection;
  getClubForm: Array<GQLClubForm>;
  getShopClubs: Array<GQLShopClub>;
  getClubDomains: Array<GQLClubDomain>;
  getClubByUrl?: Maybe<GQLShopClub>;
  getMenu?: Maybe<GQLMenu>;
  getList?: Maybe<GQLList>;
  getCart?: Maybe<GQLCartPreview>;
  getAvailableDiscountCodes: Array<GQLCartDiscountCode>;
  getCheckout?: Maybe<GQLCheckout>;
  getRmaAuthorizedService?: Maybe<GQLRmaAuthorizedService>;
  getRmaAuthorizedServices?: Maybe<GQLRmaAuthorizedServiceCollection>;
  getEshopBranches: Array<GQLEshopBranchGroup>;
  getAppNotifications?: Maybe<GQLAppNotifications>;
  verifyMyBillingAddresses?: Maybe<GQLVerificationResult>;
  getCouponsByProductIdAndDivision: Array<GQLCoupon>;
  getCouponByProductId?: Maybe<GQLCoupon>;
  getCouponByProductVariantId?: Maybe<GQLCoupon>;
  getCouponByCategoryId?: Maybe<GQLCoupon>;
  getCouponByLabelsId?: Maybe<GQLCoupon>;
  getCouponByBrandId?: Maybe<GQLCoupon>;
  getCouponByDivisionId?: Maybe<GQLCoupon>;
  getCouponByEmissionId?: Maybe<GQLCoupon>;
  /** Shop ID & User ID are taken from header x-shop-id & x-user-id. */
  getPaymentCards?: Maybe<GQLPaymentCardCollection>;
  getPaymentCard?: Maybe<GQLPaymentCard>;
  getUrlRedirect?: Maybe<GQLUrlRedirect>;
  getXsellProducts?: Maybe<GQLXsellRecommended>;
};


export type GQLQueryGetContentArgs = {
  id: Scalars['ID'];
  addContentClass?: Maybe<Scalars['Boolean']>;
  query?: Maybe<GQLGetContentQuery>;
};


export type GQLQueryGetContentByTitleArgs = {
  title: Scalars['String'];
};


export type GQLQueryGetGlossaryTermArgs = {
  term: Scalars['ID'];
};


export type GQLQueryGetAllegroLinkArgs = {
  query: GQLGetAllegroLinkQuery;
};


export type GQLQueryGetAllegroCarouselArgs = {
  limit?: Maybe<Scalars['Float']>;
};


export type GQLQueryGetShoppingWizardArgs = {
  id: Scalars['ID'];
};


export type GQLQueryGetShoppingWizardMenuIdArgs = {
  categoryId: Scalars['String'];
};


export type GQLQueryGetProductByUrlKeyArgs = {
  urlKey: Scalars['String'];
};


export type GQLQueryGetProductByIdArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type GQLQueryGetProductsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type GQLQueryGetProductVariantsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type GQLQueryGetCarouselProductsArgs = {
  query: GQLCarouselProductsInput;
};


export type GQLQueryGetProductVariantParametersDetailArgs = {
  id: Scalars['ID'];
};


export type GQLQueryGetCategoryArgs = {
  categoryUrl: Scalars['ID'];
  query?: Maybe<GQLGetCategoryQueryInput>;
};


export type GQLQueryGetCategoriesArgs = {
  categoryIds: Array<Scalars['Int']>;
  sort?: GQLCategorySort;
  replaceLinked?: Scalars['Boolean'];
};


export type GQLQueryGetCanonicalUrlArgs = {
  categoryUrl: Scalars['ID'];
  urlQuery: Scalars['String'];
};


export type GQLQueryGetFiltersCollectionArgs = {
  query: GQLGetFiltersQueryInput;
};


export type GQLQueryGetBonusSetArgs = {
  id: Scalars['String'];
  outputFilter?: Maybe<Scalars['String']>;
};


export type GQLQueryGetBonusSetByUrlArgs = {
  url: Scalars['String'];
};


export type GQLQueryGetBonusSetsArgs = {
  ids: Array<Scalars['String']>;
};


export type GQLQueryGetPageBannersArgs = {
  pageUrl: Scalars['ID'];
};


export type GQLQueryGetPositionedPageBannersArgs = {
  pageUrl: Scalars['ID'];
  query: GQLGetPageBannerBannersQueryInput;
};


export type GQLQueryGetCampaignArgs = {
  campaignId: Scalars['String'];
  query?: Maybe<GQLGetCampaignQueryInput>;
};


export type GQLQueryGetProductDiscussionCollectionArgs = {
  productId: Scalars['ID'];
  pagination?: Maybe<GQLPaginationInput>;
};


export type GQLQueryGetProductReviewsArgs = {
  productId: Scalars['ID'];
  pagination?: Maybe<GQLPaginationInput>;
  filter?: Maybe<GQLGetReviewFilter>;
  sort?: Maybe<Array<GQLGetReviewSort>>;
};


export type GQLQueryGetProductReviewBoxArgs = {
  productId: Scalars['ID'];
};


export type GQLQueryGetMyProductReviewsArgs = {
  variantIds: Array<Scalars['ID']>;
};


export type GQLQueryGetReviewsMsgsTokenValidationArgs = {
  token: Scalars['String'];
};


export type GQLQueryGetShopInShopArgs = {
  query: GQLShopInShopInput;
};


export type GQLQueryGetTranslationsArgs = {
  namespaces: Array<Maybe<Scalars['ID']>>;
};


export type GQLQueryGetWishListArgs = {
  wishListId?: Maybe<Scalars['ID']>;
};


export type GQLQueryGetWishListByHashArgs = {
  hash: Scalars['String'];
  pagination?: Maybe<GQLPaginationInput>;
};


export type GQLQueryGetAutocompleteArgs = {
  text: Scalars['String'];
  params?: Maybe<GQLSearchParams>;
};


export type GQLQueryGetSearchArgs = {
  text: Scalars['String'];
  query: GQLGetSearchQueryInput;
  params?: Maybe<GQLSearchParams>;
};


export type GQLQueryQuRedirectExistsArgs = {
  text: Scalars['String'];
  params?: Maybe<GQLSearchParams>;
};


export type GQLQueryGetMyPaymentCardArgs = {
  id: Scalars['ID'];
};


export type GQLQueryGetFinancialOffersArgs = {
  query: GQLGetFinancialOffersInput;
};


export type GQLQueryGetInstallmentsTilesArgs = {
  query: GQLGetInstallmentsTilesInput;
};


export type GQLQueryGetInstallmentsSliderArgs = {
  query: GQLGetInstallmentsSliderInput;
};


export type GQLQueryGetInstallmentsCalculationArgs = {
  query: GQLGetInstallmentsCalculationInput;
};


export type GQLQueryGetInstallmentsInsurancesArgs = {
  query: GQLGetInstallmentsInsurancesInput;
};


export type GQLQueryGetOrdersArgs = {
  pagination?: Maybe<GQLPaginationInput>;
};


export type GQLQueryGetOrderArgs = {
  id: Scalars['ID'];
};


export type GQLQueryGetOrderFromTokenArgs = {
  token: Scalars['String'];
};


export type GQLQueryGetOrderInvoiceArgs = {
  orderId: Scalars['ID'];
  invoiceId: Scalars['ID'];
};


export type GQLQueryGetDigitalContentOrderArgs = {
  orderId: Scalars['ID'];
};


export type GQLQueryGetDigitalContentProductKeyArgs = {
  authorizationId: Scalars['String'];
  productKeyId: Scalars['String'];
};


export type GQLQueryGetCustomerClubArgs = {
  clubId: Scalars['ID'];
};


export type GQLQueryGetClubSubscriptionsArgs = {
  clubId: Scalars['ID'];
};


export type GQLQueryGetClubFormArgs = {
  clubId: Scalars['ID'];
};


export type GQLQueryGetShopClubsArgs = {
  showProtected?: Scalars['Boolean'];
};


export type GQLQueryGetClubDomainsArgs = {
  domain?: Maybe<Scalars['String']>;
};


export type GQLQueryGetClubByUrlArgs = {
  url: Scalars['String'];
};


export type GQLQueryGetMenuArgs = {
  menuId: GQLMenuId;
};


export type GQLQueryGetListArgs = {
  listLabel: Scalars['String'];
};


export type GQLQueryGetRmaAuthorizedServiceArgs = {
  id: Scalars['ID'];
};


export type GQLQueryGetCouponsByProductIdAndDivisionArgs = {
  productId: Scalars['ID'];
  division?: Maybe<Scalars['String']>;
};


export type GQLQueryGetCouponByProductIdArgs = {
  id: Scalars['ID'];
};


export type GQLQueryGetCouponByProductVariantIdArgs = {
  id: Scalars['ID'];
};


export type GQLQueryGetCouponByCategoryIdArgs = {
  id: Scalars['ID'];
};


export type GQLQueryGetCouponByLabelsIdArgs = {
  id: Scalars['String'];
};


export type GQLQueryGetCouponByBrandIdArgs = {
  id: Scalars['ID'];
};


export type GQLQueryGetCouponByDivisionIdArgs = {
  id: Scalars['String'];
};


export type GQLQueryGetCouponByEmissionIdArgs = {
  id: Scalars['Float'];
};


export type GQLQueryGetPaymentCardArgs = {
  id: Scalars['ID'];
};


export type GQLQueryGetUrlRedirectArgs = {
  fromUrl: Scalars['String'];
};


export type GQLQueryGetXsellProductsArgs = {
  variantId: Scalars['ID'];
  query: GQLRecommendedProductsQuery;
};

export type GQLRangeInput = {
  min: Scalars['Float'];
  max: Scalars['Float'];
};

export type GQLRangeNumber = {
  __typename?: 'RangeNumber';
  min: Scalars['Float'];
  max: Scalars['Float'];
};

export type GQLRank = {
  __typename?: 'Rank';
  rank: Scalars['Float'];
  count: Scalars['Int'];
  textRankingCount: Scalars['Int'];
};

export type GQLRecommendedProductsQuery = {
  provider: GQLXsellRecommendedProductsProvider;
  limit?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type GQLRepayResponse = {
  __typename?: 'RepayResponse';
  gatewayUrl?: Maybe<Scalars['String']>;
  /** Can be anything, returned as JSON string */
  additionalData?: Maybe<Scalars['String']>;
};

export type GQLReviewMedia = {
  __typename?: 'ReviewMedia';
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type GQLReviewMediaInput = {
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type GQLReviewsMsgsJwk = {
  __typename?: 'ReviewsMsgsJwk';
  kty: Scalars['String'];
  use: Scalars['String'];
  n: Scalars['String'];
  e: Scalars['String'];
};

export type GQLReviewsMsgsTokenValidation = {
  __typename?: 'ReviewsMsgsTokenValidation';
  isValid: Scalars['Boolean'];
};

export type GQLReviewStats = {
  __typename?: 'ReviewStats';
  ranksCount: Scalars['Int'];
  averageRank: Scalars['Float'];
  messagesCount: Scalars['Int'];
  stars: Array<GQLStarsHistogram>;
};

export type GQLReviewUsefulness = {
  __typename?: 'ReviewUsefulness';
  value: Scalars['Int'];
  count: Scalars['Int'];
  positiveCount: Scalars['Int'];
  negativeCount: Scalars['Int'];
};



export type GQLRmaAuthorizedService = {
  __typename?: 'RmaAuthorizedService';
  id: Scalars['ID'];
  title: Scalars['String'];
  company: Scalars['String'];
  complaintProcedure?: Maybe<Scalars['SanitizedString']>;
  contacts?: Maybe<GQLRmaContentContacts>;
};

export type GQLRmaAuthorizedServiceCollection = {
  __typename?: 'RmaAuthorizedServiceCollection';
  items: Array<GQLRmaAuthorizedService>;
  hits: Scalars['Int'];
};

export type GQLRmaContentContacts = {
  __typename?: 'RmaContentContacts';
  id: Scalars['ID'];
  phone?: Maybe<Scalars['String']>;
  phone2?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  email2?: Maybe<Scalars['String']>;
  web?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
};



export type GQLSapCategories = {
  __typename?: 'SapCategories';
  productTypeId?: Maybe<Scalars['String']>;
  segment?: Maybe<Scalars['String']>;
};

export type GQLSearchParams = {
  useMirror?: Maybe<Scalars['Boolean']>;
  abTestId?: Maybe<Scalars['Int']>;
  userDbUi?: Maybe<Scalars['String']>;
  abTestValue?: Maybe<Scalars['String']>;
  includeDynamicFacets?: Maybe<Scalars['Boolean']>;
};

export type GQLSearchQuRedirectBrand = {
  __typename?: 'SearchQuRedirectBrand';
  brand: Scalars['String'];
};

export type GQLSearchQuRedirectCategory = {
  __typename?: 'SearchQuRedirectCategory';
  /** one of category, infopage or signpost must be setted */
  category?: Maybe<Scalars['String']>;
  infopage?: Maybe<Scalars['String']>;
  signpost?: Maybe<Scalars['String']>;
  brands: Array<Scalars['String']>;
  /** params should be type of { [key: string]: string[] } */
  params?: Maybe<Scalars['Object']>;
};

export type GQLSearchQuRedirectDetail = {
  __typename?: 'SearchQuRedirectDetail';
  product?: Maybe<GQLProduct>;
};

export type GQLSearchQuRedirectFulltext = {
  __typename?: 'SearchQuRedirectFulltext';
  categories: Array<Scalars['String']>;
  brands: Array<Scalars['String']>;
  /** params should be type of { [key: string]: string[] } */
  params?: Maybe<Scalars['Object']>;
  searchRedirect?: Maybe<Scalars['String']>;
};

export type GQLSearchQuRedirectLicence = {
  __typename?: 'SearchQuRedirectLicence';
  license: Scalars['String'];
};

export type GQLSearchQuRedirectMarketplacePartner = {
  __typename?: 'SearchQuRedirectMarketplacePartner';
  marketplacePartner: Scalars['String'];
};

export type GQLSearchQuRedirectPurchase = {
  __typename?: 'SearchQuRedirectPurchase';
  purchaseId: Scalars['String'];
};

export type GQLSearchResult = GQLSearchResultItems | GQLSearchUrlRedirect | GQLSearchQuRedirectCategory | GQLSearchQuRedirectFulltext | GQLSearchQuRedirectDetail | GQLSearchQuRedirectPurchase | GQLSearchQuRedirectLicence | GQLSearchQuRedirectMarketplacePartner | GQLSearchQuRedirectBrand;

export type GQLSearchResultItemCategoryBoost = {
  __typename?: 'SearchResultItemCategoryBoost';
  path?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['PositiveInt']>;
  score?: Maybe<Scalars['Float']>;
  pathScore?: Maybe<Scalars['Float']>;
};

export type GQLSearchResultItems = {
  __typename?: 'SearchResultItems';
  items: Array<GQLProductCollectionItems>;
  bestsellers: Array<GQLProduct>;
  categoryBoost: Array<GQLSearchResultItemCategoryBoost>;
  itemsTotalCount: Scalars['Int'];
  filters?: Maybe<Array<GQLProductFilter>>;
  inaccurateResult: Scalars['Boolean'];
  navigationItems: Array<GQLSearchResultNavigationItems>;
  exactMatchCategory?: Maybe<GQLCategory>;
};


export type GQLSearchResultItemsCategoryBoostArgs = {
  pagination?: Maybe<GQLPaginationInput>;
};

export type GQLSearchResultNavigationItems = {
  __typename?: 'SearchResultNavigationItems';
  title: Scalars['String'];
  url: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
};

export type GQLSearchSuggestKeyword = {
  __typename?: 'SearchSuggestKeyword';
  phrase: Scalars['String'];
  minChars: Scalars['Int'];
};

export type GQLSearchSuggestLink = {
  __typename?: 'SearchSuggestLink';
  keywords: Array<GQLSearchSuggestKeyword>;
  title: Scalars['String'];
  searchPhrase: Scalars['String'];
  imageId?: Maybe<Scalars['Int']>;
};

export type GQLSearchUrlRedirect = {
  __typename?: 'SearchUrlRedirect';
  url: Scalars['String'];
};

export type GQLSecondPrice = {
  __typename?: 'SecondPrice';
  link: Scalars['String'];
  price: Scalars['Float'];
  text: Scalars['String'];
  type: GQLSecondPriceType;
};

export enum GQLSecondPriceType {
  Discount = 'DISCOUNT',
  Installments = 'INSTALLMENTS',
  MallPayDiscount = 'MALL_PAY_DISCOUNT'
}

export type GQLSectionBanner = {
  __typename?: 'SectionBanner';
  bannerId: Scalars['ID'];
  bannerSlidesDesktop?: Maybe<Array<GQLSectionBannerSlide>>;
  bannerSlidesMobile?: Maybe<Array<GQLSectionBannerSlide>>;
  bannerSlidesApp?: Maybe<Array<GQLSectionBannerSlide>>;
};

export type GQLSectionBannerSlide = GQLSectionBannerSlideImage | GQLSectionBannerSlideProduct;

export type GQLSectionBannerSlideBase = {
  slideId: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  urlNewWindow: Scalars['Boolean'];
  inCarousel: Scalars['Boolean'];
  gaTag?: Maybe<Scalars['String']>;
};

export type GQLSectionBannerSlideImage = GQLSectionBannerSlideBase & {
  __typename?: 'SectionBannerSlideImage';
  slideId: Scalars['ID'];
  urlNewWindow: Scalars['Boolean'];
  gaTag?: Maybe<Scalars['String']>;
  inCarousel: Scalars['Boolean'];
  position?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['String']>;
};

export type GQLSectionBannerSlideProduct = GQLSectionBannerSlideBase & {
  __typename?: 'SectionBannerSlideProduct';
  slideId: Scalars['ID'];
  urlNewWindow: Scalars['Boolean'];
  gaTag?: Maybe<Scalars['String']>;
  inCarousel: Scalars['Boolean'];
  position?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  product?: Maybe<GQLProduct>;
};

export type GQLSettings = {
  __typename?: 'Settings';
  onlyFirstStart?: Maybe<Scalars['Boolean']>;
  openOnce: Scalars['Boolean'];
  nextOpenAfterSeconds?: Maybe<Scalars['Int']>;
};

export type GQLShippingAddress = {
  __typename?: 'ShippingAddress';
  id: Scalars['ID'];
  street: Scalars['String'];
  city: Scalars['String'];
  zip: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  isCompany?: Maybe<Scalars['Boolean']>;
  companyName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type GQLShippingAddressCollection = {
  __typename?: 'ShippingAddressCollection';
  items: Array<GQLShippingAddress>;
  hits: Scalars['Int'];
};

export type GQLShopClub = {
  __typename?: 'ShopClub';
  id: Scalars['Int'];
  contentId?: Maybe<Scalars['Int']>;
  content?: Maybe<GQLContent>;
  title: Scalars['String'];
  type: Scalars['String'];
  yottlyCampaignName: Scalars['String'];
  trackingName: Scalars['String'];
  member: Scalars['Boolean'];
  customerStatus: Scalars['String'];
  canUnsubscribe: Scalars['Boolean'];
  urlKey?: Maybe<Scalars['String']>;
  benefits?: Maybe<Array<Maybe<GQLShopClubBenefit>>>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  backgroundImageUrlSmall?: Maybe<Scalars['String']>;
  activeBackgroundImageUrl?: Maybe<Scalars['String']>;
  activeBackgroundImageUrlSmall?: Maybe<Scalars['String']>;
};

export type GQLShopClubBenefit = {
  __typename?: 'ShopClubBenefit';
  icon?: Maybe<Scalars['String']>;
  iconActive?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type GQLShopInShop = GQLBrandSiS | GQLParametricSiS | GQLPartnerSiS;

export type GQLShopInShopInput = {
  brandUrl?: Maybe<Scalars['String']>;
  parameter?: Maybe<GQLSiSParameterInput>;
  partnerUrl?: Maybe<Scalars['String']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  pageUrl?: Maybe<Scalars['String']>;
  categoryUrl?: Maybe<Scalars['String']>;
};

export type GQLShoppingWizardAnswer = {
  __typename?: 'ShoppingWizardAnswer';
  label: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  mediaId: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  values?: Maybe<Scalars['Object']>;
  goTo?: Maybe<Scalars['String']>;
};

export type GQLShoppingWizardData = {
  __typename?: 'ShoppingWizardData';
  id: Scalars['ID'];
  title: Scalars['String'];
  questions: Array<GQLShoppingWizardQuestion>;
};

export type GQLShoppingWizardMenu = {
  __typename?: 'ShoppingWizardMenu';
  categoryId: Scalars['String'];
  wizardId: Scalars['Int'];
};

export type GQLShoppingWizardPreview = {
  __typename?: 'ShoppingWizardPreview';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type GQLShoppingWizardQuestion = {
  __typename?: 'ShoppingWizardQuestion';
  id: Scalars['Int'];
  title: Scalars['String'];
  type: Scalars['String'];
  isLast?: Maybe<Scalars['Boolean']>;
  answers: Array<GQLShoppingWizardAnswer>;
};

export type GQLShowroom = {
  __typename?: 'Showroom';
  id: Scalars['String'];
  count: Scalars['Int'];
};

export type GQLSignPostCategory = GQLCategory & {
  __typename?: 'SignPostCategory';
  id: Scalars['ID'];
  contentId?: Maybe<Scalars['Int']>;
  content?: Maybe<GQLContent>;
  footer?: Maybe<Array<GQLFooter>>;
  shoppingWizard?: Maybe<GQLShoppingWizardPreview>;
  title: Scalars['String'];
  titleFull?: Maybe<Scalars['String']>;
  titleStructured?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['Int']>;
  secondaryMediaId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  metaDescription?: Maybe<Scalars['String']>;
  metaKeywords?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  howto?: Maybe<Scalars['String']>;
  productOrder?: Maybe<Scalars['String']>;
  breadcrumbs: Array<GQLCategory>;
  children: Array<GQLCategory>;
  isRepresentative: Scalars['Boolean'];
  isMainTile: Scalars['Boolean'];
  menu: Array<GQLMixedChildren>;
  typeVersion: Scalars['Int'];
  isTrendy: Scalars['Boolean'];
  indexSeo?: Maybe<Scalars['Boolean']>;
  giftHelperUrl?: Maybe<Scalars['String']>;
  giftHelperTitle?: Maybe<Scalars['String']>;
  tilesCount?: Maybe<Scalars['Int']>;
  coupon?: Maybe<GQLCoupon>;
};


export type GQLSignPostCategoryDescriptionArgs = {
  normalizeHtml?: Maybe<GQLNormalizeInput>;
};


export type GQLSignPostCategoryChildrenArgs = {
  sort?: Maybe<GQLCategorySort>;
  visibility?: Maybe<GQLCategoryVisibility>;
};


export type GQLSignPostCategoryMenuArgs = {
  usedFilters?: Maybe<Array<GQLProductFilterValueInput>>;
};

export type GQLSiSParameterInput = {
  id: Scalars['String'];
  urlValue: Scalars['String'];
};

export type GQLSpecialMedia = {
  __typename?: 'SpecialMedia';
  mediaId: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  mimeType: Scalars['String'];
  priority: Scalars['Int'];
  switch?: Maybe<Scalars['String']>;
};

export type GQLStarsHistogram = {
  __typename?: 'StarsHistogram';
  rank: Scalars['Int'];
  ranksCount: Scalars['Int'];
  messagesCount: Scalars['Int'];
  rankPercentile: Scalars['Float'];
  rankPercent: Scalars['Float'];
};

export type GQLStep = {
  __typename?: 'Step';
  title: Scalars['String'];
  installmentCount: Scalars['Int'];
};

export type GQLSubscriptionRange = {
  __typename?: 'SubscriptionRange';
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
  deliveriesRemaining?: Maybe<Scalars['Int']>;
};

export type GQLTarget = {
  __typename?: 'Target';
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GQLTestDriveRequest = {
  __typename?: 'TestDriveRequest';
  isEnabled: Scalars['Boolean'];
  carModel?: Maybe<Scalars['String']>;
  baseUrl?: Maybe<Scalars['String']>;
};




export type GQLUnknownCategory = GQLCategory & {
  __typename?: 'UnknownCategory';
  id: Scalars['ID'];
  footer?: Maybe<Array<GQLFooter>>;
  shoppingWizard?: Maybe<GQLShoppingWizardPreview>;
  title: Scalars['String'];
  titleFull?: Maybe<Scalars['String']>;
  titleStructured?: Maybe<Scalars['String']>;
  mediaId?: Maybe<Scalars['Int']>;
  secondaryMediaId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  metaDescription?: Maybe<Scalars['String']>;
  metaKeywords?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  howto?: Maybe<Scalars['String']>;
  productOrder?: Maybe<Scalars['String']>;
  breadcrumbs: Array<GQLCategory>;
  children: Array<GQLCategory>;
  isRepresentative: Scalars['Boolean'];
  isMainTile: Scalars['Boolean'];
  menu: Array<GQLMixedChildren>;
  typeVersion: Scalars['Int'];
  isTrendy: Scalars['Boolean'];
  indexSeo?: Maybe<Scalars['Boolean']>;
  giftHelperUrl?: Maybe<Scalars['String']>;
  giftHelperTitle?: Maybe<Scalars['String']>;
  coupon?: Maybe<GQLCoupon>;
};


export type GQLUnknownCategoryDescriptionArgs = {
  normalizeHtml?: Maybe<GQLNormalizeInput>;
};


export type GQLUnknownCategoryChildrenArgs = {
  sort?: Maybe<GQLCategorySort>;
  visibility?: Maybe<GQLCategoryVisibility>;
};


export type GQLUnknownCategoryMenuArgs = {
  usedFilters?: Maybe<Array<GQLProductFilterValueInput>>;
};



export type GQLUpdateAppNotificationsInput = {
  token?: Maybe<Scalars['String']>;
  device?: Maybe<Scalars['String']>;
  os?: Maybe<Scalars['String']>;
  newsCheck?: Maybe<Scalars['Boolean']>;
  orderStateCheck?: Maybe<Scalars['Boolean']>;
  reviewsCheck?: Maybe<Scalars['Boolean']>;
};

export type GQLUpdateBillingAddressInput = {
  id: Scalars['ID'];
  street: Scalars['String'];
  city: Scalars['String'];
  zip: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  cid?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
};

export type GQLUpdateMeInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  cid?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  allowNewsletterEmail?: Maybe<Scalars['Boolean']>;
  allowNewsletterSms?: Maybe<Scalars['Boolean']>;
  allowAdultContent?: Maybe<Scalars['Boolean']>;
  street?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type GQLUpdateProductReviewInput = {
  id: Scalars['ID'];
  variantId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  showAuthor?: Maybe<Scalars['Boolean']>;
  rank: Scalars['Float'];
  message?: Maybe<Scalars['String']>;
  cons?: Maybe<Array<Scalars['String']>>;
  pros?: Maybe<Array<Scalars['String']>>;
  medias?: Maybe<Array<GQLReviewMediaInput>>;
  imageUploads?: Maybe<Array<Scalars['Upload']>>;
};

export type GQLUpdateShippingAddressInput = {
  id: Scalars['ID'];
  street: Scalars['String'];
  city: Scalars['String'];
  zip: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};


export type GQLUpperRightCornerBanner = {
  __typename?: 'UpperRightCornerBanner';
  bannerId: Scalars['ID'];
  slideId: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  urlNewWindow: Scalars['Boolean'];
  mediaId?: Maybe<Scalars['String']>;
  gaTag?: Maybe<Scalars['String']>;
};


export type GQLUrlRedirect = {
  __typename?: 'UrlRedirect';
  id: Scalars['ID'];
  finalUrl: Scalars['String'];
  redirectCode: Scalars['Int'];
};

export type GQLUsefulnessInput = {
  value: Scalars['Int'];
  uniqueKey: Scalars['String'];
};

export type GQLUser = {
  __typename?: 'User';
  id: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  isCompany: Scalars['Boolean'];
  companyName?: Maybe<Scalars['String']>;
  cid?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  notifications: GQLUserNotificationSettings;
  billingAddresses: GQLBillingAddressCollection;
  shippingAddresses: GQLShippingAddressCollection;
  partnerId?: Maybe<Scalars['Int']>;
  allowAdultContent: Scalars['Boolean'];
  pricingGroup?: Maybe<Scalars['String']>;
  vipType?: Maybe<Scalars['String']>;
  clubs?: Maybe<Array<GQLUserClub>>;
  paymentCards: GQLPaymentCardCollection;
  vipDiscountLimit?: Maybe<GQLVipDiscountLimit>;
  hasPassword: Scalars['Boolean'];
  consentList: Array<GQLCustomerConsent>;
  /** @deprecated Use isSmartTrialActivable instead */
  isSmartActive: Scalars['Boolean'];
  isSmartTrialActivable: Scalars['Boolean'];
  cartId?: Maybe<Scalars['String']>;
  watchdogs?: Maybe<GQLWatchdogCollection>;
};


export type GQLUserConsentListArgs = {
  all?: Maybe<Scalars['Boolean']>;
};

export type GQLUserClub = {
  __typename?: 'UserClub';
  id: Scalars['ID'];
  label: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  pricingGroup?: Maybe<Scalars['String']>;
};

export type GQLUserNotificationSettings = {
  __typename?: 'UserNotificationSettings';
  allowNewsletterEmail: Scalars['Boolean'];
  allowNewsletterSms: Scalars['Boolean'];
};



export type GQLV2CustomerClubSubscription = {
  __typename?: 'V2CustomerClubSubscription';
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
  deliveriesUsed: Scalars['Int'];
};

export type GQLVariantDataBrand = {
  __typename?: 'VariantDataBrand';
  id: Scalars['String'];
  title: Scalars['String'];
};

export type GQLVariantDataExtendedWarranty = {
  __typename?: 'VariantDataExtendedWarranty';
  type: Scalars['String'];
  price: Scalars['Float'];
  decimalsRound: Scalars['Float'];
  vatRate: Scalars['Float'];
};

export type GQLVariantDataInstallationService = {
  __typename?: 'VariantDataInstallationService';
  type: Scalars['String'];
  percentRate: Scalars['Float'];
};

export type GQLVariantDataInsurance = {
  __typename?: 'VariantDataInsurance';
  type: Scalars['String'];
  price: Scalars['Float'];
  decimalsRound: Scalars['Float'];
  vatRate: Scalars['Float'];
};

export type GQLVariantDataReturn60DaysService = {
  __typename?: 'VariantDataReturn60DaysService';
  type: Scalars['String'];
  price: Scalars['Float'];
  decimalsRound: Scalars['Float'];
  vatRate: Scalars['Float'];
};

export type GQLVariantDataSize = {
  __typename?: 'VariantDataSize';
  depth: Scalars['Float'];
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type GQLVariantDataWeight = {
  __typename?: 'VariantDataWeight';
  brutto: Scalars['Float'];
  netto: Scalars['Float'];
};

export type GQLVariantParameterMeasure = {
  __typename?: 'VariantParameterMeasure';
  measureId: Scalars['String'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type GQLVariantStickersInput = {
  useCase?: Maybe<GQLVariantStickerUseCase>;
};

export enum GQLVariantStickerUseCase {
  Campaign = 'CAMPAIGN',
  List = 'LIST',
  Detail = 'DETAIL'
}

export type GQLVerificationResult = {
  __typename?: 'VerificationResult';
  message: Scalars['String'];
};

export type GQLViewTarget = {
  __typename?: 'ViewTarget';
  type: Scalars['String'];
  value: Scalars['String'];
};

export type GQLVipDiscountLimit = {
  __typename?: 'VIPDiscountLimit';
  max: Scalars['Float'];
  current: Scalars['Float'];
  isReached: Scalars['Boolean'];
  documentId: Scalars['Float'];
  limitsRenewal: Scalars['String'];
};


export type GQLWatchdog = {
  __typename?: 'Watchdog';
  id: Scalars['ID'];
  variantId: Scalars['String'];
  product?: Maybe<GQLProduct>;
  validTo?: Maybe<Scalars['DateTime']>;
};

export type GQLWatchdogCollection = {
  __typename?: 'WatchdogCollection';
  id: Scalars['ID'];
  items: Array<GQLWatchdog>;
};

export type GQLWatchdogInput = {
  variantId: Scalars['ID'];
};

export type GQLWishList = {
  __typename?: 'WishList';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  isMain?: Maybe<Scalars['Boolean']>;
  totalCount?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<GQLWishListItem>>>;
  hash?: Maybe<Scalars['String']>;
};


export type GQLWishListItemsArgs = {
  pagination?: Maybe<GQLPaginationInput>;
};

export type GQLWishListByHash = {
  __typename?: 'WishListByHash';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  isMain?: Maybe<Scalars['Boolean']>;
  totalCount?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<GQLWishListItem>>>;
  hash?: Maybe<Scalars['String']>;
};

export type GQLWishListInput = {
  title: Scalars['String'];
  note: Scalars['String'];
  isPublic?: Maybe<Scalars['Boolean']>;
};

export type GQLWishListItem = {
  __typename?: 'WishListItem';
  id?: Maybe<Scalars['ID']>;
  amount?: Maybe<Scalars['Int']>;
  createdDateTime?: Maybe<Scalars['DateTime']>;
  product?: Maybe<GQLProduct>;
  variant?: Maybe<GQLProductVariant>;
};

export type GQLWishListItemIdInput = {
  wishListId: Scalars['ID'];
  wishListItemId: Scalars['ID'];
};

export type GQLWishListItemInput = {
  wishListId: Scalars['ID'];
  variantId: Scalars['ID'];
  amount?: Maybe<Scalars['Int']>;
};

export type GQLWishListItemUpdateInput = {
  amount?: Maybe<Scalars['Int']>;
};

export type GQLXsellBaseProduct = GQLXsellProduct & {
  __typename?: 'XsellBaseProduct';
  id: Scalars['ID'];
  product?: Maybe<GQLProduct>;
  groupsIds: Array<Scalars['ID']>;
};

export type GQLXsellGroup = {
  __typename?: 'XsellGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GQLXsellProduct = {
  id: Scalars['ID'];
  product?: Maybe<GQLProduct>;
};

export type GQLXsellRecommended = {
  __typename?: 'XsellRecommended';
  products: Array<GQLXsellRecommendedProduct>;
  groups: Array<GQLXsellGroup>;
};

export type GQLXsellRecommendedProduct = GQLXsellBaseProduct | GQLXsellTipProduct;

export enum GQLXsellRecommendedProductsProvider {
  Xsell = 'XSELL',
  Exponea = 'EXPONEA',
  Databeakers = 'DATABEAKERS',
  Bi = 'BI'
}

export type GQLXsellTipProduct = GQLXsellProduct & {
  __typename?: 'XsellTipProduct';
  id: Scalars['ID'];
  advantagesParameters: Array<Scalars['String']>;
  product?: Maybe<GQLProduct>;
  parameters: Array<Maybe<GQLProductParameter>>;
  advantagesLabels: Array<Scalars['String']>;
  disadvantagesLabels: Array<Scalars['String']>;
  disadvantagesParameters: Array<Scalars['String']>;
};
